import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { MainAdminAccess } from './AdminAccess';
import { useAuth } from '../hooks/useAuth';
import { Button, Container, Row, Col, Card, Table, Spinner, Form, Modal, Alert } from 'react-bootstrap';
import '../styles/AdminPanel.css';
import { fetchOrders, removeOrderItem, completeOrder, updateOrderStatus, getSalesHistoryDay, getSalesHistoryMonth } from '../http/orderAPI';
import { createProduct, fetchCategories, fetchStores, fetchProducts, createCategory, updateCategory, fetchProductByBarcode, fetchSizes, deleteCategory, deleteZeroStockProducts, recalculateAllProductQuantities, applyDiscountByCategory } from '../http/productAPI';
import { createSale } from '../http/orderAPI';
import EditProductModal from './EditProductModal';
import DeleteProductModal from './DeleteProductModal';
import ChangeLog from './ChangeLog';
import InvoicesStorage from './InvoicesStorage';
import { useNavigate } from 'react-router-dom';
import { UNIVERSAL_REPORT_ROUTE } from '../utils/consts';
import { $authHost } from '../http/index';
import { useToast } from '../contexts/ToastContext';
import useModalCleanup from '../hooks/useModalCleanup';
import { getImageUrl } from '../utils/imageUtils';

const statusOptions = [
    { value: 'pending', label: 'В ожидании' },
    { value: 'processing', label: 'В обработке' },
    { value: 'delivered', label: 'Доставлен' },
];

// Lightbox компонент для показа изображения
function Lightbox({ src, alt, onClose }) {
  if (!src) return null;
  return (
    <div className="lightbox-backdrop" onClick={onClose}>
      <div className="lightbox-content" onClick={e => e.stopPropagation()}>
        <img src={src} alt={alt} className="lightbox-img" />
        <button className="lightbox-close" onClick={onClose}>✖</button>
      </div>
    </div>
  );
}

const AdminPanel = () => {
    const { user } = useAuth();
    const [activeTab, setActiveTab] = useState('orders');
    const [orders, setOrders] = useState([]);
    const [loadingOrders, setLoadingOrders] = useState(false);
    const [ordersError, setOrdersError] = useState('');

    // --- История продаж ---
    const [salesMode, setSalesMode] = useState('day');
    const [salesDate, setSalesDate] = useState('');
    const [salesYear, setSalesYear] = useState(new Date().getFullYear());
    const [salesMonth, setSalesMonth] = useState(new Date().getMonth() + 1);
    const [sales, setSales] = useState([]);
    const [loadingSales, setLoadingSales] = useState(false);
    const [salesError, setSalesError] = useState('');

    // --- Добавление товара ---
    const [categories, setCategories] = useState([]);
    const [stores, setStores] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedStore, setSelectedStore] = useState('');
    const [type, setType] = useState('shoe');
    const [name, setName] = useState('');
    const [price, setPrice] = useState(0);
    const [file, setFile] = useState(null);
    const [description, setDescription] = useState('');
    const [material, setMaterial] = useState('');
    const [color, setColor] = useState('');
    const [gender, setGender] = useState('мужской');
    const [toyQuantity, setToyQuantity] = useState(1);
    const [availableSizes, setAvailableSizes] = useState([]);
    const [variantSize, setVariantSize] = useState('');
    const [variantColor, setVariantColor] = useState('');
    const [variantQuantity, setVariantQuantity] = useState(1);
    const [variantBarcode, setVariantBarcode] = useState('');
    const [variantStoreId, setVariantStoreId] = useState('');
    const [variants, setVariants] = useState([]);
    const [newVariant, setNewVariant] = useState({ name: '', quantity: 1, barcode: '', article: '' });
    const [barcode, setBarcode] = useState('');
    const [article, setArticle] = useState('');
    const [ageRating, setAgeRating] = useState('');
    const [products, setProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(false);
    const [productsError, setProductsError] = useState('');

    // --- Добавление категории ---
    const [showAddCategory, setShowAddCategory] = useState(false);
    const [categoryName, setCategoryName] = useState('');
    const [categoryType, setCategoryType] = useState('shoe');
    const [categoryParentId, setCategoryParentId] = useState('');
    const [categoryError, setCategoryError] = useState('');
    const [showCategoryConfirm, setShowCategoryConfirm] = useState(false);

    // --- Редактирование и удаление товаров ---
    const [deleteProductVisible, setDeleteProductVisible] = useState(false);
    const [productToDelete, setProductToDelete] = useState(null);

    // --- Продажа (SalesForm) ---
    const [showSaleForm, setShowSaleForm] = useState(false);
    const [selectedSize, setSelectedSize] = useState('');
    const [scannedProducts, setScannedProducts] = useState([]);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [saleError, setSaleError] = useState('');
    const [saleSuccess, setSaleSuccess] = useState('');

    const [foundVariants, setFoundVariants] = useState([]);
    const [selectedVariantIdx, setSelectedVariantIdx] = useState(-1);

    // --- Новые состояния для множественных товаров ---
    const [multipleProducts, setMultipleProducts] = useState([]);
    const [selectedProductIdx, setSelectedProductIdx] = useState(-1);
    const [showProductSelection, setShowProductSelection] = useState(false);

    const [editProductId, setEditProductId] = useState(null);
    const [editModalVisible, setEditModalVisible] = useState(false);

    // --- Состояние для сортировки истории продаж ---
    const [salesSort, setSalesSort] = useState('date_desc'); // date_desc, date_asc

    const [productSearch, setProductSearch] = useState('');

    // --- Состояния для фильтрации товаров ---
    const [selectedType] = useState('');
    const [searchTerm] = useState('');

    const [paymentType, setPaymentType] = useState('cash'); // 'cash' или 'card'

    const [showReturnModal, setShowReturnModal] = useState(false);
    const [saleToReturn, setSaleToReturn] = useState(null);

    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentTypeForOrder, setPaymentTypeForOrder] = useState('cash');
    const [orderToComplete, setOrderToComplete] = useState(null);

    const [userEmail, setUserEmail] = useState('');
    const [userDiscount, setUserDiscount] = useState(0);
    const [userFound, setUserFound] = useState(null);
    const [userDiscountError, setUserDiscountError] = useState('');

    const [userBarcode, setUserBarcode] = useState('');

    const navigate = useNavigate();

    const { showToast } = useToast();

    const [lightboxImg, setLightboxImg] = useState(null);

    const [customPrice, setCustomPrice] = useState('');

    // --- состояние для фильтра по типу продукции ---
    const [productTypeFilter, setProductTypeFilter] = useState('');

    const [verificationStats, setVerificationStats] = useState(null);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('');

    // --- Добавление товара ---
    const [images, setImages] = useState([]);
    const fileInputRef = useRef();

    const [isLoading, setIsLoading] = useState(false);

    const [editCategoryModal, setEditCategoryModal] = useState(false);
    const [categoryToEdit, setCategoryToEdit] = useState(null);
    const [editCategoryName, setEditCategoryName] = useState('');
    const [editCategoryType, setEditCategoryType] = useState('shoe');
    const [editCategoryParentId, setEditCategoryParentId] = useState('');
    const [deleteCategoryModal, setDeleteCategoryModal] = useState(false);
    const [categoryToDelete, setCategoryToDelete] = useState(null);
    const [categoryActionError, setCategoryActionError] = useState('');
    const [categoryDiscountModal, setCategoryDiscountModal] = useState(false);
    const [discountCategory, setDiscountCategory] = useState(null);
    const [categoryDiscountValue, setCategoryDiscountValue] = useState('');
    const [categoryDiscountLoading, setCategoryDiscountLoading] = useState(false);

    const [selectedSalesStore, setSelectedSalesStore] = useState(''); // Для фильтрации продаж по магазину

    // Лимиты отображаемых элементов (товары/продажи)
    const [visibleProductsCount, setVisibleProductsCount] = useState(20);
    const [visibleSalesCount, setVisibleSalesCount] = useState(20);

    const [productSortBy] = useState('quantity_desc'); // quantity_desc, quantity_asc

    // 1. Состояние для сортировки
    const [productSortDirection, setProductSortDirection] = useState('desc'); // 'asc' или 'desc'

    const justClosedEditModal = useRef(false);
    const blockEditClick = useRef(false);

    const editButtonRefs = useRef({});
    const [editButtonTabIndex, setEditButtonTabIndex] = useState({});

    const lastFocusedElement = useRef(null);

    const blockFocusRef = useRef(false);

    // 2. Функция для получения количества товара
    const getProductQuantity = (product) => {
      if (!product) return 0;
      // Для товаров с вариантами (shoe, clothes, toy) суммируем количество из вариантов
      if ((product.type === 'shoe' || product.type === 'clothes' || product.type === 'toy') && Array.isArray(product.variants) && product.variants.length > 0) {
        return (product.variants || []).reduce((sum, v) => sum + (Number(v.quantity) || 0), 0);
      }
      if (product.type === 'toy') {
        // Если нет вариантов, используем product_stores или stock как fallback
        if (Array.isArray(product.product_stores) && product.product_stores.length > 0) {
          return product.product_stores.reduce((sum, ps) => sum + (Number(ps.quantity) || 0), 0);
        }
        return Number(product.stock ?? 0) || 0;
      }
      if (product.type === 'shoe' || product.type === 'clothes') {
        return (product.variants || []).reduce((sum, v) => sum + (Number(v.quantity) || 0), 0);
      }
      // Для прочих типов — пробуем взять из product_stores
      if (Array.isArray(product.product_stores) && product.product_stores.length > 0) {
        return product.product_stores.reduce((sum, ps) => sum + (Number(ps.quantity) || 0), 0);
      }
      return 0;
    };

    // 1. Сначала фильтрация
    const filteredProducts = useMemo(() => {
        return products.filter(product => {
            // Тип товара
            const productType = product.type || (product.toy ? 'toy' : null);
            if (productTypeFilter && productType !== productTypeFilter) {
                return false;
            }
            // Фильтрация по поиску (название, артикул, категория, штрих-код)
            if (productSearch) {
                const searchLower = productSearch.toLowerCase();
                const nameMatch = product.name?.toLowerCase().includes(searchLower);
                const articleMatch = (product.article || product.clothes?.article || '').toLowerCase().includes(searchLower);
                const categoryMatch = product.category?.name?.toLowerCase().includes(searchLower);
                const barcodeMatch = [
                    product.barcode,
                    product.toy?.barcode,
                    ...(Array.isArray(product.variants) ? product.variants.map(v => v.barcode) : [])
                ]
                  .filter(Boolean)
                  .map(v => String(v).toLowerCase())
                  .some(b => b.includes(searchLower));
                if (!nameMatch && !articleMatch && !categoryMatch && !barcodeMatch) {
                    return false;
                }
            }
            // Фильтрация по категории
            if (selectedCategory && product.category_id !== selectedCategory.id) {
                return false;
            }
            return true;
        });
    }, [products, productTypeFilter, selectedCategory, productSearch]);

    // 2. Затем сортировка
    const sortedProducts = [...filteredProducts].sort((a, b) => {
        const qa = getProductQuantity(a);
        const qb = getProductQuantity(b);
        return productSortDirection === 'asc' ? qa - qb : qb - qa;
    });

    // 3. Пагинация товаров для отображения (ограничиваем до visibleProductsCount)
    const paginatedProducts = useMemo(
        () => sortedProducts.slice(0, visibleProductsCount),
        [sortedProducts, visibleProductsCount]
    );

    // --- Обработчики для категорий ---
    const handleEditCategory = (category) => {
      setCategoryToEdit(category);
      setEditCategoryName(category.name);
      setEditCategoryType(category.type);
      setEditCategoryParentId(category.parent_id || '');
      setEditCategoryModal(true);
      setCategoryActionError('');
    };
    const handleEditCategorySave = async () => {
      if (!editCategoryName.trim()) {
        setCategoryActionError('Название не может быть пустым');
        return;
      }
      if (categoryToEdit && editCategoryParentId && editCategoryParentId === categoryToEdit.id) {
        setCategoryActionError('Категория не может быть родителем самой себя');
        return;
      }
      try {
        console.log('=== EDITING CATEGORY ===');
        console.log('Category ID:', categoryToEdit.id);
        console.log('New name:', editCategoryName);
        console.log('New type:', editCategoryType);
        console.log('New parent_id:', editCategoryParentId || null);
        
        await updateCategory(categoryToEdit.id, { 
          name: editCategoryName, 
          type: editCategoryType,
          parent_id: editCategoryParentId || null
        }); 
        console.log('Category updated successfully');
        
        setEditCategoryModal(false);
        setCategoryToEdit(null);
        setEditCategoryName('');
        setEditCategoryType('shoe');
        setEditCategoryParentId('');
        fetchCategories().then(data => setCategories(data));
      } catch (e) {
        console.error('Error updating category:', e);
        setCategoryActionError('Ошибка при изменении категории');
      }
    };
    const handleDeleteCategory = (category) => {
      setCategoryToDelete(category);
      setDeleteCategoryModal(true);
      setCategoryActionError('');
    };
    const handleDeleteCategoryConfirm = async () => {
      try {
        await deleteCategory(categoryToDelete.id);
        setDeleteCategoryModal(false);
        setCategoryToDelete(null);
        fetchCategories().then(data => setCategories(data));
      } catch (e) {
        setCategoryActionError('Ошибка при удалении категории');
      }
    };

    const handleOpenCategoryDiscount = (category) => {
      setDiscountCategory(category);
      setCategoryDiscountValue('');
      setCategoryDiscountModal(true);
      setCategoryActionError('');
    };

    const handleApplyCategoryDiscount = async () => {
      if (!discountCategory) return;
      const value = Number(categoryDiscountValue);
      if (!Number.isFinite(value) || value < 0 || value > 100) {
        setCategoryActionError('Введите скидку от 0 до 100');
        return;
      }
      try {
        setCategoryDiscountLoading(true);
        const response = await applyDiscountByCategory(discountCategory.id, value);
        showToast(response?.message || 'Скидка успешно применена', 'success');
        setCategoryDiscountModal(false);
        setDiscountCategory(null);
        setCategoryDiscountValue('');
        setCategoryActionError('');
        // Перезагружаем товары, чтобы увидеть новые скидки в каталоге
        try {
          setLoadingProducts(true);
          const data = await fetchProducts();
          if (data && Array.isArray(data.rows)) {
            setProducts(data.rows);
          } else if (Array.isArray(data)) {
            setProducts(data);
          }
          setProductsError('');
        } catch (reloadError) {
          console.error('Error reloading products after category discount:', reloadError);
        } finally {
          setLoadingProducts(false);
        }
      } catch (e) {
        console.error('Error applying category discount:', e);
        setCategoryActionError(e?.response?.data?.message || 'Ошибка при применении скидки');
      } finally {
        setCategoryDiscountLoading(false);
      }
    };

    // 2. Функция поиска пользователя по email
    const handleUserEmailBlur = async () => {
        setUserDiscountError('');
        setUserFound(null);
        setUserDiscount(0);
        if (!userEmail) return;
        try {
            const res = await $authHost.get(`/api/user/by-email?email=${encodeURIComponent(userEmail)}`);
            if (res.data && res.data.personal_discount !== undefined) {
                setUserFound(res.data);
                setUserDiscount(Number(res.data.personal_discount) || 0);
            } else {
                setUserDiscountError('Пользователь не найден или нет скидки');
            }
        } catch (e) {
            setUserDiscountError('Пользователь не найден');
        }
    };

    // Поиск пользователя по barcode
    const handleUserBarcodeBlur = async () => {
        setUserDiscountError('');
        setUserFound(null);
        setUserDiscount(0);
        setUserEmail('');
        if (!userBarcode) return;
        try {
            const { data } = await $authHost.get(`/api/user/by-barcode?barcode=${encodeURIComponent(userBarcode)}`);
            setUserFound(data);
            setUserDiscount(data.personal_discount || 0);
            setUserEmail(data.email || '');
        } catch (e) {
            setUserDiscountError('Пользователь с таким штрих-кодом не найден');
            setUserFound(null);
            setUserDiscount(0);
            setUserEmail('');
        }
    };

    // --- Управление заказами ---
    const loadOrders = async () => {
        setLoadingOrders(true);
        setOrdersError('');
        try {
            const data = await fetchOrders();
            setOrders(data);
        } catch (e) {
            setOrdersError('Ошибка при загрузке заказов');
        } finally {
            setLoadingOrders(false);
        }
    };

    useEffect(() => {
        if (activeTab === 'orders') loadOrders();
    }, [activeTab]);

    const handleRemoveItem = async (orderItemId) => {
        if (!window.confirm('Удалить товар из заказа и вернуть на склад?')) return;
        try {
            await removeOrderItem(orderItemId);
            loadOrders();
        } catch (e) {
            alert('Ошибка при удалении товара из заказа');
        }
    };

    const handleCompleteOrder = (orderId) => {
        setOrderToComplete(orderId);
        setPaymentTypeForOrder('cash');
        setShowPaymentModal(true);
    };

    const confirmCompleteOrder = async () => {
        if (!orderToComplete) return;
        try {
            await completeOrder(orderToComplete, paymentTypeForOrder);
            setShowPaymentModal(false);
            setOrderToComplete(null);
            loadOrders();
        } catch (e) {
            alert('Ошибка при завершении заказа');
        }
    };

    const handleStatusChange = async (orderId, status) => {
        try {
            await updateOrderStatus(orderId, status);
            loadOrders();
        } catch (e) {
            alert('Ошибка при изменении статуса заказа');
        }
    };

    // --- Сортировка истории продаж по дате ---
    const sortedSales = [...sales].sort((a, b) => {
        const dA = a.dateTime ? new Date(a.dateTime.split(',')[0].split('.').reverse().join('-') + 'T' + a.dateTime.split(',')[1].trim()) : 0;
        const dB = b.dateTime ? new Date(b.dateTime.split(',')[0].split('.').reverse().join('-') + 'T' + b.dateTime.split(',')[1].trim()) : 0;
        return salesSort === 'date_desc' ? dB - dA : dA - dB;
    });

    // Фильтрация продаж по магазину (только для main_admin)
    const filteredSales = user.role === 'main_admin' && selectedSalesStore
        ? sortedSales.filter(
            sale => String(sale.store_id ?? sale.storeId ?? '') === String(selectedSalesStore)
        )
        : sortedSales;

    // Пагинация продаж для отображения (ограничиваем до visibleSalesCount)
    const visibleSales = useMemo(
        () => (Array.isArray(filteredSales) ? filteredSales.slice(0, visibleSalesCount) : []),
        [filteredSales, visibleSalesCount]
    );

    const fetchSales = useCallback(async () => {
        setLoadingSales(true);
        setSalesError('');
        try {
            let data = [];
            if (salesMode === 'day') {
                data = await getSalesHistoryDay(salesDate);
            } else {
                data = await getSalesHistoryMonth(salesYear, salesMonth);
            }
            setSales(data);
            // при каждой новой выборке начинаем показ продаж с первых 20
            setVisibleSalesCount(20);
        } catch (e) {
            setSalesError('Ошибка при получении истории продаж');
        } finally {
            setLoadingSales(false);
        }
    }, [salesMode, salesDate, salesYear, salesMonth]);

    const loadProducts = useCallback(async () => {
        setLoadingProducts(true);
        setProductsError('');
        try {
            let params = { limit: 10000 };
            if (user.role === 'store_admin' && user.store_id) {
                params.store_id = user.store_id;
            }
            const data = await fetchProducts(params);
            
            // Исправление: всегда проставлять type для игрушек и добавлять защиту
            const fixedProducts = (data.rows || []).map(p => {
                // Если у товара нет type, но есть toy, то это игрушка
                if (!p.type && p.toy) {
                    return { ...p, type: 'toy' };
                }
                // Если у товара есть type 'toy', но нет toy объекта, создаем его
                if (p.type === 'toy' && !p.toy) {
                    return { 
                        ...p, 
                        toy: { 
                            material: p.material || null, 
                            age_rating: null, 
                            quantity: p.stock || 0 
                        } 
                    };
                }
                return p;
            });
            
            setProducts(fixedProducts);
            // при загрузке товаров отображаем только первые 20
            setVisibleProductsCount(20);
        } catch (e) {
            setProductsError('Ошибка загрузки товаров');
            console.error('Ошибка загрузки товаров:', e);
        } finally {
            setLoadingProducts(false);
        }
    }, [user.role, user.store_id]);

    useEffect(() => {
        fetchCategories().then(data => {
            setCategories(data);
            console.log('Категории:', data);
        });
        fetchStores().then(data => {
            console.log('Получены магазины с сервера:', data);
            setStores(data);
            console.log('Магазины установлены в состояние:', data);
        }).catch(error => {
            console.error('Ошибка при загрузке магазинов:', error);
        });
        loadProducts();
    }, [loadProducts]);

    useEffect(() => {
        setMaterial('');
        setColor('');
        setGender('мужской');
        setVariantSize('');
        setVariantColor('');
        setVariantQuantity(1);
        setVariantBarcode('');
        setVariantStoreId('');
        setVariants([]);
        setSelectedCategory(null);
        setAvailableSizes([]);
    }, [type]);

    useEffect(() => {
        if (type === 'shoe') {
            fetchSizes('shoe').then(setAvailableSizes);
        } else if (type === 'clothes' && selectedCategory) {
            const catName = selectedCategory.name;
            if (catName === 'Бюстгальтер' || catName === 'Трусы') {
                fetchSizes('clothes', catName).then(setAvailableSizes);
            } else if (catName === 'Носки') {
                fetchSizes('clothes', 'Носки').then(sizes => {
                    setAvailableSizes(sizes.filter(s => s.category === 'Носки'));
                });
            } else {
                fetchSizes('clothes').then(sizes => {
                    // Только без категории (обычная одежда)
                    setAvailableSizes(sizes.filter(s => !s.category));
                });
            }
        } else {
            setAvailableSizes([]);
        }
    }, [type, selectedCategory]);

    const handleVariantChange = (idx, field, value) => {
        setVariants(prev => prev.map((v, i) => i === idx ? { ...v, [field]: value } : v));
    };

    const handleAddVariant = () => {
        if (type === 'toy') {
            if (!newVariant.name || !newVariant.quantity || Number(newVariant.quantity) < 1) {
                showToast('Укажите название и количество варианта', 'error');
                return;
            }
            // Для store_admin автоматически устанавливаем его store_id
            const storeIdToUse = user.role === 'store_admin' && user.store_id 
                ? user.store_id 
                : (newVariant.storeId || selectedStore);
            
            setVariants(prev => {
                const isDup = prev.some(v => v.name === newVariant.name && (v.storeId || storeIdToUse) === storeIdToUse);
                if (isDup) {
                    showToast('Такой вариант уже добавлен (название + магазин)', 'error');
                    return prev;
                }
                return [...prev, { ...newVariant, storeId: storeIdToUse }];
            });
            setNewVariant({ name: '', quantity: 1, barcode: '', article: '' });
            return;
        }

        // обувь/одежда
        const allowedSizes = availableSizes.map(s => String(s.value));
        if (!variantSize || !allowedSizes.includes(variantSize) || !variantColor || variantQuantity === '' || isNaN(Number(variantQuantity)) || Number(variantQuantity) < 1 || !variantBarcode) {
            showToast('Пожалуйста, заполните все поля корректно', 'error');
            return;
        }
        // Для store_admin автоматически устанавливаем его store_id
        const storeIdToUse = user.role === 'store_admin' && user.store_id 
            ? user.store_id 
            : (variantStoreId || selectedStore);
        
        setVariants(prevVariants => {
            const isDuplicate = prevVariants.some(v => v.size === variantSize && v.color === variantColor && (v.storeId || storeIdToUse) === storeIdToUse);
            if (isDuplicate) {
                showToast('Такой вариант уже добавлен (размер, цвет и магазин совпадают)', 'error');
                return prevVariants;
            }
            const variantObj = {
                size: variantSize,
                color: variantColor,
                quantity: Number(variantQuantity),
                barcode: variantBarcode,
                storeId: storeIdToUse
            };
            return [...prevVariants, variantObj];
        });
        setVariantSize('');
        setVariantColor('');
        setVariantQuantity(1);
        setVariantBarcode('');
        setVariantStoreId('');
    };

    const handleRemoveVariant = (idx) => {
        setVariants(variants.filter((_, i) => i !== idx));
    };

    const addProduct = async () => {
        setIsLoading(true);
        try {
            if (!selectedCategory || !selectedCategory.id) {
                showToast('Выберите категорию товара', 'error');
                return;
            }
            let storeId = selectedStore;
            if (user.role === 'store_admin') {
                storeId = user.store_id;
            }
            if (!storeId) {
                showToast('Выберите магазин', 'error');
                return;
            }
            if (!name) {
                showToast('Введите название товара', 'error');
                return;
            }
            if (!price || price < 0) {
                showToast('Введите корректную стоимость товара (неотрицательное число)', 'error');
                return;
            }
            if (!images || images.length === 0) {
                showToast('Выберите хотя бы одно изображение товара', 'error');
                return;
            }
            if (type === 'toy' && variants.length === 0 && !barcode) {
                showToast('Введите штрих-код для игрушки (если нет вариантов)', 'error');
                return;
            }
            if (type !== 'toy' && type !== 'clothes' && type !== 'shoe' && !description) {
                showToast('Введите описание товара', 'error');
                return;
            }
            if (type === 'toy' && variants.length === 0 && (!toyQuantity || toyQuantity < 1)) {
                showToast('Введите корректное количество для игрушки (целое положительное число)', 'error');
                return;
            }
            // Проверка штрих-кода только если нет вариантов
            if (type === 'toy' && variants.length === 0 && (!barcode || barcode.trim() === '')) {
                showToast('Введите штрих-код для игрушки', 'error');
                return;
            }
            const formData = new FormData();
            formData.append('name', name.trim());
            formData.append('price', `${price}`);
            formData.append('description', description);
            images.forEach((img, i) => formData.append('images', img.file));
            formData.append('category_id', String(selectedCategory.id));
            formData.append('store_id', String(storeId));
            formData.append('type', type);
            if (type === 'shoe' || type === 'clothes') {
                if (variants.length === 0) {
                    setTimeout(() => alert('Добавьте хотя бы один вариант товара (размер+цвет+количество+штрих-код)'), 0);
                    return;
                }
                formData.append('variants', JSON.stringify(variants));
            }
            if (type === 'shoe') {
                formData.append('gender', gender);
                formData.append('article', article);
            }
            if (type === 'clothes') {
                formData.append('material', material);
                formData.append('article', article);
            }
            if (type === 'toy') {
                formData.append('barcode', barcode);
                formData.append('material', material);
                formData.append('quantity', toyQuantity);
                formData.append('color', color);
                formData.append('age_rating', ageRating);
                // Отправляем варианты игрушек, если они есть
                if (variants.length > 0) {
                    formData.append('variants', JSON.stringify(variants));
                }
            }
            try {
                await createProduct(formData);
                showToast('Товар успешно добавлен!', 'success');
                loadProducts();
                setName(''); setPrice(0); setImages([]); setDescription(''); setMaterial(''); setColor(''); setGender('мужской'); setVariants([]); setBarcode(''); setToyQuantity(1); setAgeRating('');
            } catch (error) {
                if (error.response?.data?.message) {
                    showToast(`Ошибка при добавлении товара: ${error.response.data.message}`, 'error');
                } else {
                    showToast('Произошла ошибка при добавлении товара. Проверьте консоль для деталей.', 'error');
                }
            }
        } finally {
            setIsLoading(false);
        }
    };

    const addCategory = async () => {
        if (!categoryName.trim()) {
            setCategoryError('Название категории не может быть пустым');
            return;
        }
        if (!categoryType) {
            setCategoryError('Выберите тип категории');
            return;
        }
        try {
            await createCategory({ 
              name: categoryName, 
              type: categoryType,
              parent_id: categoryParentId || null
            });
            setCategoryName('');
            setCategoryType('shoe');
            setCategoryParentId('');
            setCategoryError('');
            setShowAddCategory(false);
            fetchCategories().then(data => setCategories(data));
        } catch (e) {
            setCategoryError('Ошибка при добавлении категории');
        }
    };

    // --- Редактирование и удаление товаров ---
    const handleUpdateProduct = (product, e) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      lastFocusedElement.current = document.activeElement;
        setEditProductId(product.id);
        setEditModalVisible(true);
    };

    const handleDeleteProduct = (product) => {
        setProductToDelete(product);
        setDeleteProductVisible(true);
    };

    const handleProductDeleted = () => {
        setDeleteProductVisible(false);
        setProductToDelete(null);
        loadProducts();
    };

    const handleEditProductModalClose = () => {
      setSelectedProductIdx(-1);
      setCurrentProduct(null);
      setEditModalVisible(false);
      setEditProductId(null);
      // 1. Все кнопки "Изменить" делаем временно не фокусируемыми
      const prevTabIndex = { ...editButtonTabIndex };
      const ids = Object.keys(editButtonRefs.current);
      const newTabIndex = {};
      ids.forEach(id => { newTabIndex[id] = -1; });
      setEditButtonTabIndex(newTabIndex);
      setTimeout(() => {
        setEditButtonTabIndex(prevTabIndex);
      }, 300);
      // 2. Снимаем фокус с любого элемента и фокусируем body
      blockFocusRef.current = true;
      setTimeout(() => {
        blockFocusRef.current = false;
      }, 500);
      setTimeout(() => {
        if (document.activeElement) document.activeElement.blur();
        if (document.body) document.body.focus();
        lastFocusedElement.current = null;
      }, 0);
    };

    const handleEditProductSave = () => {
        // Чтобы страницы товара в других вкладках обновлялись после сохранения
        const updatedProductId = editProductId;
        setEditModalVisible(false);
        setEditProductId(null);
      setSelectedProductIdx(-1);
      setCurrentProduct(null);
        loadProducts();

      try {
        const bc = new window.BroadcastChannel('product_update');
        if (updatedProductId) bc.postMessage({ productId: updatedProductId });
        bc.close();
      } catch (_) {
        // ignore
      }
      // 1. Все кнопки "Изменить" делаем временно не фокусируемыми
      const prevTabIndex = { ...editButtonTabIndex };
      const ids = Object.keys(editButtonRefs.current);
      const newTabIndex = {};
      ids.forEach(id => { newTabIndex[id] = -1; });
      setEditButtonTabIndex(newTabIndex);
      setTimeout(() => {
        setEditButtonTabIndex(prevTabIndex);
      }, 300);
      // 2. Снимаем фокус с любого элемента и фокусируем body
      blockFocusRef.current = true;
      setTimeout(() => {
        blockFocusRef.current = false;
      }, 500);
      setTimeout(() => {
        if (document.activeElement) document.activeElement.blur();
        if (document.body) document.body.focus();
        lastFocusedElement.current = null;
      }, 0);
    };

    const handleBarcodeSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetchProductByBarcode(barcode);
            // ЛОГИРОВАНИЕ: что пришло с сервера
            console.log('[DEBUG][handleBarcodeSubmit] response:', response);
            // Проверяем, есть ли несколько товаров с этим штрих-кодом
            if (response.multipleProducts && response.products && response.products.length > 1) {
                setMultipleProducts(response.products);
                setSelectedProductIdx(-1);
                setShowProductSelection(true);
                setSaleError('');
                return;
            }
            // Если один товар - обрабатываем как раньше
            if (response) {
                setCurrentProduct(response);
                setSaleError('');
                // Фильтруем варианты по магазину для store_admin
                let variantsToSet = response.variants || [];
                if (user.role === 'store_admin' && user.store_id && variantsToSet.length > 0) {
                    variantsToSet = variantsToSet.filter(v => v.storeId === user.store_id);
                }
                
                if (variantsToSet.length > 0) {
                    setFoundVariants(variantsToSet);
                    if (variantsToSet.length === 1) {
                        setSelectedVariantIdx(0);
                    } else {
                        setSelectedVariantIdx(-1);
                    }
                } else {
                    setFoundVariants([]);
                    setSelectedVariantIdx(-1);
                }
            } else {
                setSaleError('Товар не найден');
            }
        } catch (e) {
            setSaleError('Ошибка при поиске товара');
        }
    };

    const handleProductSelection = (productIdx) => {
        setSelectedProductIdx(productIdx);
        const selectedProduct = multipleProducts[productIdx];
        setCurrentProduct(selectedProduct);
        setShowProductSelection(false);
        setMultipleProducts([]);
        setSaleError(''); // Сброс ошибки
        // Фильтруем варианты по магазину для store_admin
        let variantsToSet = selectedProduct.variants || [];
        if (user.role === 'store_admin' && user.store_id && variantsToSet.length > 0) {
            variantsToSet = variantsToSet.filter(v => v.storeId === user.store_id);
        }
        
        // Устанавливаем варианты для выбранного товара
        if (variantsToSet.length > 0) {
            setFoundVariants(variantsToSet);
            setSelectedVariantIdx(-1); // Сброс выбора варианта
        } else {
            setFoundVariants([]);
            setSelectedVariantIdx(-1);
        }
        // Сбрасываем количество игрушки при выборе нового товара
        setToyQuantity(1);
        // customPrice не сбрасываем!
    };

    const handleCancelProductSelection = () => {
        setShowProductSelection(false);
        setMultipleProducts([]);
        setSelectedProductIdx(-1);
        setBarcode('');
        setSaleError('');
        // Сбрасываем количество игрушки при отмене выбора
        setToyQuantity(1);
    };

    const handleCloseSaleForm = () => {
        setShowSaleForm(false);
        setScannedProducts([]);
        setCurrentProduct(null);
        setBarcode('');
        setSelectedSize('');
        setFoundVariants([]);
        setSelectedVariantIdx(-1);
        setCustomPrice('');
        setSaleError('');
        setSaleSuccess('');
        setUserEmail('');
        setUserDiscount(0);
        setUserFound(null);
        setUserDiscountError('');
        // Сбрасываем количество игрушки для новой продажи
        setToyQuantity(1);
        
        // Очищаем состояния множественных товаров
        setMultipleProducts([]);
        setSelectedProductIdx(-1);
        setShowProductSelection(false);
        setToyQuantity(1);
    };

    const handleAddToSale = () => {
        if (!currentProduct) return;
        let productToAdd;
        // --- Исправление для игрушек ---
        if (currentProduct.type === 'toy') {
            let variant = null;
            if (Array.isArray(foundVariants) && foundVariants.length > 0) {
                if (foundVariants.length > 1 && selectedVariantIdx === -1) {
                    setSaleError('Выберите вариант игрушки');
                    return;
                }
                variant = foundVariants[selectedVariantIdx === -1 ? 0 : selectedVariantIdx];
                // Проверяем количество выбранного варианта
                if (variant && (variant.quantity || 0) <= 0) {
                    setSaleError('Выбранный вариант товара отсутствует в наличии');
                    return;
                }
                // Проверяем, что запрашиваемое количество не превышает доступное
                if (variant && toyQuantity > (variant.quantity || 0)) {
                    setSaleError(`Недостаточно товара. Доступно: ${variant.quantity} шт.`);
                    return;
                }
            }
            // Требуем штрих-код: из варианта или из товара (фоллбек)
            const barcodeToUse = variant?.barcode || currentProduct.barcode || '';
            if (!barcodeToUse) {
                setSaleError('Введите штрих-код для игрушки или варианта');
                return;
            }
            const priceToUse = customPrice !== ''
                ? Number(customPrice)
                : (variant?.price_with_discount ?? variant?.price ?? currentProduct.price_with_discount ?? currentProduct.price);
            const storeIdToUse = variant?.storeId || (user.role === 'main_admin' ? selectedStore : user.store_id) || currentProduct.store_id || currentProduct.product_stores?.[0]?.storeId || null;
            productToAdd = {
                id: currentProduct.id,
                name: variant?.name || currentProduct.name,
                price: priceToUse,
                barcode: barcodeToUse,
                store_id: storeIdToUse,
                quantity: toyQuantity,
                variant
            };
        } else if (currentProduct.type === 'shoe' || currentProduct.type === 'clothes') {
            let variant = null;
            let size = '';
            // Всегда используем выбранный вариант
            if (foundVariants.length > 0 && selectedVariantIdx >= 0) {
                variant = foundVariants[selectedVariantIdx];
                size = variant.size || '';
            } else {
                setSaleError('Выберите вариант!');
                return;
            }
            // --- Новое: используем customPrice или price_with_discount ---
            const priceToUse = customPrice !== '' 
                ? Number(customPrice) 
                : (variant?.price_with_discount ?? variant?.price ?? currentProduct.price_with_discount ?? currentProduct.price);
            // --- ЛОГИРОВАНИЕ ---
            console.log('[DEBUG] Добавление товара в продажу:', {
                currentProduct,
                variant,
                selectedSize: size,
                priceToUse,
                selectedVariantIdx,
                foundVariants
            });
            productToAdd = {
                ...currentProduct,
                variant,
                selectedSize: size, // Уникальный размер для этого варианта
                price: priceToUse,
                quantity: 1 // Добавляем количество по умолчанию
            };
        } else {
            setSaleError('Тип товара не поддерживается!');
            return;
        }
        setScannedProducts([...scannedProducts, productToAdd]);
        setCurrentProduct(null);
        setBarcode('');
        setSelectedSize('');
        setFoundVariants([]);
        setSelectedVariantIdx(-1);
        setCustomPrice('');
        setSaleError('');
    };

    const handleRemoveProduct = (index) => {
        const newProducts = [...scannedProducts];
        newProducts.splice(index, 1);
        setScannedProducts(newProducts);
    };

    // Изменение количества для игрушек в списке продажи
    const handleChangeProductQuantity = (index, value) => {
        const newQuantityRaw = Number(value);
        const newQuantity = Number.isFinite(newQuantityRaw) && newQuantityRaw > 0 ? Math.floor(newQuantityRaw) : 1;
        setScannedProducts(prev => {
            const next = [...prev];
            const item = { ...next[index] };
            // Ограничиваем максимумом доступного остатков для игрушек
            let maxQty = item.product_stores?.[0]?.quantity || item.toy?.quantity || item.stock || undefined;
            if (item.type === 'toy' && Number.isFinite(maxQty)) {
                item.quantity = Math.min(newQuantity, Number(maxQty));
            } else {
                item.quantity = newQuantity;
            }
            next[index] = item;
            return next;
        });
    };

    const handleFinishSale = async () => {
        try {
            // Проверяем, что у каждого товара с типом clothes/shoe есть размер
            for (const p of scannedProducts) {
                if ((p.type === 'clothes' || p.type === 'shoe') && !p.selectedSize && !(p.variant && p.variant.size)) {
                    setSaleError('У всех товаров должен быть выбран размер!');
                    return;
                }
            }
            // Добавляем store_id для каждого товара
            let storeId = '';
            if (user.role === 'main_admin') {
                storeId = selectedStore;
            } else if (user.role === 'store_admin') {
                storeId = user.store_id;
            }
            if (!storeId) {
                setSaleError('Выберите магазин для продажи!');
                return;
            }
            const productsWithStore = scannedProducts.map(p => {
                let priceWithDiscount = p.price;
                if (userDiscount > 0) {
                    priceWithDiscount = p.price * (1 - userDiscount / 100);
                }
                // Определяем sizeId
                let sizeId = p.sizeId;
                let size = p.selectedSize;
                if (!sizeId && p.selectedSize && p.sizes && Array.isArray(p.sizes)) {
                    const foundSize = p.sizes.find(sz => sz.value === p.selectedSize);
                    if (foundSize) sizeId = foundSize.id;
                }
                // size/value для фронта
                if (!size && p.variant && p.variant.size) {
                    size = p.variant.size;
                }
                return { ...p, store_id: storeId, price_with_discount: priceWithDiscount, sizeId, size };
            });
            await handleCreateSale(productsWithStore);
            setTimeout(() => {
                fetchSales(); // обновить историю продаж
            }, 1200);
        } catch (e) {
            setTimeout(() => alert('Ошибка при завершении продажи'), 0);
        }
    };

    const handleCreateSale = async (products) => {
        try {
            await createSale(products, paymentType, userEmail);
            // Очищаем все состояния формы продажи
            setShowSaleForm(false);
            setScannedProducts([]);
            setCurrentProduct(null);
            setBarcode('');
            setSelectedSize('');
            setFoundVariants([]);
            setSelectedVariantIdx(-1);
            setSaleError('');
            setSaleSuccess('Заказ успешно создан');
            setUserEmail('');
            setUserDiscount(0);
            setUserFound(null);
            setUserDiscountError('');
            // Сбрасываем количество игрушек для новой продажи
            setToyQuantity(1);
            
            // Очищаем состояния множественных товаров
            setMultipleProducts([]);
            setSelectedProductIdx(-1);
            setShowProductSelection(false);
            
            // Обновляем данные после создания заказа
            await Promise.all([
                loadProducts(),
                loadOrders(),
                fetchSales()
            ]);
            // === ПАТЧ: уведомляем все вкладки о продаже ===
            const bc = new window.BroadcastChannel('product_update');
            products.forEach(p => bc.postMessage({ productId: p.id }));
            bc.close();
        } catch (error) {
            console.error('Error creating sale:', error);
            setSaleError('Ошибка при создании заказа');
        }
    };

    useEffect(() => {
        if (activeTab === 'reports') {
            fetchCategories().then(setCategories);
        }
    }, [activeTab]);



    const handleReturnSale = (sale) => {
        setSaleToReturn(sale);
        setShowReturnModal(true);
    };

    // Функция для извлечения UUID из sale.id (если есть суффикс _0)
    function getSaleUUID(id) {
      if (typeof id === 'string' && id.includes('_')) {
        return id.split('_')[0];
      }
      return id;
    }

    const handleCloseReturnModal = useCallback(() => {
      setShowReturnModal(false);
      setSaleToReturn(null);
    }, []);

    const confirmReturnSale = async () => {
        if (!saleToReturn) return;
        try {
            await $authHost.post('/api/returns', { saleId: getSaleUUID(saleToReturn.id) });
            fetchSales();
            handleCloseReturnModal();
            showToast('Возврат успешно оформлен!', 'success');
        } catch (e) {
            handleCloseReturnModal();
            showToast('Ошибка возврата: ' + (e?.response?.data?.message || e.message), 'error');
        }
    };

    useEffect(() => { fetchSales(); }, [fetchSales]);

    const handleClosePaymentModal = () => {
        setShowPaymentModal(false);
    };

    useModalCleanup(showReturnModal);
    useModalCleanup(showPaymentModal);

    const fetchVerificationStats = async () => {
        try {
            setLoading(true);
            const response = await $authHost.get('/api/user/verification-stats');
            setVerificationStats(response.data);
        } catch (error) {
            console.error('Ошибка получения статистики:', error);
            setMessage('Ошибка при получении статистики верификации');
            setMessageType('danger');
        } finally {
            setLoading(false);
        }
    };

    const cleanupExpiredTokens = async () => {
        try {
            setLoading(true);
            const response = await $authHost.post('/api/user/cleanup-expired-tokens');
            setMessage(`Очищено ${response.data.cleanedCount} истекших токенов`);
            setMessageType('success');
            // Обновляем статистику после очистки
            await fetchVerificationStats();
        } catch (error) {
            console.error('Ошибка очистки токенов:', error);
            setMessage('Ошибка при очистке истекших токенов');
            setMessageType('danger');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchVerificationStats();
    }, []);

    // Drag & Drop обработка для изображений
    const handleDrop = (e) => {
      e.preventDefault();
      const files = Array.from(e.dataTransfer.files).filter(f => f.type.startsWith('image/'));
      addFiles(files);
    };
    const handleFileChange = (e) => {
      const files = Array.from(e.target.files).filter(f => f.type.startsWith('image/'));
      addFiles(files);
    };
    const addFiles = (files) => {
      const newImgs = files.map(file => ({ file, url: URL.createObjectURL(file) }));
      setImages(prev => [...prev, ...newImgs]);
    };
    const handleRemoveImage = (idx) => {
      const img = images[idx];
      setImages(prev => prev.filter((_, i) => i !== idx));
      if (img.url) URL.revokeObjectURL(img.url);
    };
    const dragEvents = {
      onDragOver: e => e.preventDefault(),
      onDrop: handleDrop,
      onClick: () => fileInputRef.current && fileInputRef.current.click(),
      style: { border: '2px dashed #aaa', borderRadius: 8, padding: 16, textAlign: 'center', cursor: 'pointer', marginBottom: 16, background: '#fafafa' }
    };

    // Добавить функцию в компонент AdminPanel:
    function getSizeValueById(sizeId) {
        if (!currentProduct || !Array.isArray(currentProduct.sizes)) return sizeId;
        const found = currentProduct.sizes.find(sz => sz.id === sizeId);
        return found ? found.value : sizeId;
    }

    // --- Маппинг цветов (можно вынести в utils при необходимости) ---
    const colorMap = {
      '1': 'Черный',
      '2': 'Белый',
      '3': 'Красный',
      '4': 'Синий',
      '5': 'Зеленый',
      '6': 'Желтый',
      '7': 'Серый',
      '8': 'Бежевый',
      '9': 'Коричневый',
      '10': 'Розовый',
      // ... добавить по необходимости
    };
    function getColorName(color) {
      if (!color) return '-';
      if (Array.isArray(color)) return color.map(getColorName).join(', ');
      return colorMap[color] || color;
    }

    // useEffect для сброса customPrice и selectedVariantIdx при смене currentProduct
    useEffect(() => {
        setSelectedVariantIdx(-1);
    }, [currentProduct]);

    // ЛОГИРОВАНИЕ: выводим найденные варианты и выбранный индекс
    useEffect(() => {
        if (currentProduct && Array.isArray(foundVariants)) {
            console.log('[DEBUG] Текущий продукт:', currentProduct);
            console.log('[DEBUG] Найденные варианты:', foundVariants);
            console.log('[DEBUG] Выбранный вариант (selectedVariantIdx):', selectedVariantIdx);
            if (foundVariants.length > 0) {
                foundVariants.forEach((v, idx) => {
                    console.log(`[DEBUG] Вариант #${idx}: size=`, v.size, 'color=', v.color, 'storeId=', v.storeId, 'barcode=', v.barcode, 'article=', v.article);
                });
            }
        }
    }, [currentProduct, foundVariants, selectedVariantIdx]);

    // Глобальный useEffect для снятия фокуса с кнопок "Изменить"
    useEffect(() => {
      function handleFocusIn(e) {
        if (blockFocusRef.current && e.target !== document.body) {
          e.preventDefault && e.preventDefault();
          e.stopPropagation && e.stopPropagation();
          if (e.target.blur) e.target.blur();
          if (document.body) document.body.focus();
        }
      }
      document.addEventListener('focusin', handleFocusIn, true);
      return () => document.removeEventListener('focusin', handleFocusIn, true);
    }, []);

    return (
        <Container className="admin-panel">
            <div className="admin-tabs">
                <Button 
                    variant={activeTab === 'orders' ? 'primary' : 'outline-primary'}
                    onClick={() => setActiveTab('orders')}
                >
                    Заказы
                </Button>
                <Button 
                    variant={activeTab === 'products' ? 'primary' : 'outline-primary'}
                    onClick={() => setActiveTab('products')}
                >
                    Товары
                </Button>
                <Button 
                    variant={activeTab === 'sales' ? 'primary' : 'outline-primary'}
                    onClick={() => setActiveTab('sales')}
                >
                    Продажи
                </Button>
                {user.role !== 'store_admin' && (
                    <Button 
                        variant={activeTab === 'verification' ? 'primary' : 'outline-primary'}
                        onClick={() => setActiveTab('verification')}
                    >
                        Верификация Email
                    </Button>
                )}
                <MainAdminAccess>
                    <Button 
                        variant="outline-primary"
                        onClick={() => navigate(UNIVERSAL_REPORT_ROUTE)}
                    >
                        Универсальный отчет
                    </Button>
                    <Button 
                        variant={activeTab === 'changelog' ? 'primary' : 'outline-primary'}
                        onClick={() => setActiveTab('changelog')}
                    >
                        Журнал последних изменений
                    </Button>
                    <Button 
                        variant={activeTab === 'invoices' ? 'primary' : 'outline-primary'}
                        onClick={() => setActiveTab('invoices')}
                    >
                        Накладные
                    </Button>
                </MainAdminAccess>
            </div>
            <Row>
                <Col>
                    {activeTab === 'orders' && (
                        <Card>
                            <Card.Body>
                                <h3>Управление заказами</h3>
                                {loadingOrders && <Spinner animation="border" />}
                                {ordersError && <div className="text-danger mb-2">{ordersError}</div>}
                                {Array.isArray(orders) && orders.length === 0 && !loadingOrders && (
                                    <div>Нет заказов</div>
                                )}
                                {/* Таблица заказов для десктопа */}
                                <div className="table-responsive d-none d-md-block mb-3">
                                    <Table bordered size="sm" className="align-middle text-nowrap">
                                        <thead>
                                            <tr>
                                                <th>№ заказа</th>
                                                <th>Пользователь</th>
                                                <th>Дата</th>
                                                <th>Статус</th>
                                                <th>Цвет</th>
                                                <th>Товары</th>
                                                <th>Сумма</th>
                                                <th>Действия</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(orders) && orders.map(order => {
                                                const totalWithProductDiscount = order.order_items.reduce(
                                                    (sum, item) => sum + ((item.price_with_discount !== undefined && item.price_with_discount !== null
                                                        ? Number(item.price_with_discount)
                                                        : (item.product?.price || 0)) * item.quantity), 0
                                                );
                                                const discountPercent = Number(order.discount_percent) || 0;
                                                const discountAmount = discountPercent > 0 ? totalWithProductDiscount * discountPercent / 100 : 0;
                                                const totalWithAllDiscounts = totalWithProductDiscount - discountAmount;
                                                return (
                                                    <tr key={order.id}>
                                                        <td>{order.order_short_id}</td>
                                                        <td>{order.user?.name || 'Гость'}<br />({order.user?.email || 'Нет email'})</td>
                                                        <td>{new Date(order.created_at).toLocaleString()}</td>
                                                        <td>
                                                            <Form.Select
                                                                style={{ display: 'inline-block', width: 'auto', minWidth: 120 }}
                                                                value={order.status}
                                                                onChange={e => handleStatusChange(order.id, e.target.value)}
                                                                disabled={order.status === 'completed'}
                                                                size="sm"
                                                            >
                                                                {statusOptions.map(opt => (
                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                ))}
                                                                {order.status === 'completed' && (
                                                                    <option value="completed">Выполнен</option>
                                                                )}
                                                            </Form.Select>
                                                        </td>
                                                        <td>
                                                            {(Array.isArray(order.order_items) ? order.order_items : []).map(item => (
                                                                <div key={item.id}>{item.color || item.variant?.color || '-'}</div>
                                                            ))}
                                                        </td>
                                                        <td>
                                                            {(Array.isArray(order.order_items) ? order.order_items : []).map(item => (
                                                                <div key={item.id} style={{marginBottom:4, display:'flex', alignItems:'center', gap:8, flexWrap:'wrap'}}>
                                                                  {item.product?.image_url && (
                                                                    <img
                                                                      src={getImageUrl(item.product.image_url)}
                                                                      alt={item.product?.name}
                                                                      style={{width:36, height:36, objectFit:'cover', borderRadius:6, marginRight:6, background:'#f3f3f3'}}
                                                                    />
                                                                  )}
                                                                  <div style={{minWidth:0, flex:1}}>
                                                                    <b style={{wordBreak:'break-word'}}>{item.product?.name}</b> x{item.quantity}<br />
                                                                    <span style={{fontSize:12}}>
                                                                        {item.product?.type === 'toy' && item.variant?.name 
                                                                            ? `Вариант: ${item.variant.name}` 
                                                                            : item.size?.value || '-'} | {item.product?.shoe?.article || item.product?.clothes?.article || item.product?.article || '-'}
                                                                    </span>
                                                                  </div>
                                                                  <button
                                                                    className="order-delete-btn"
                                                                    onClick={() => handleRemoveItem(item.id)}
                                                                    disabled={order.status === 'completed'}
                                                                    style={{padding:'2px 8px', fontSize:13, borderRadius:6, border:'none', background:'#eee', color:'#d00', cursor:'pointer'}}
                                                                    title="Удалить товар из заказа"
                                                                  >
                                                                    🗑️
                                                                  </button>
                                                                </div>
                                                            ))}
                                                        </td>
                                                        <td>
                                                            <span style={{ textDecoration: 'line-through', color: '#888', marginRight: 8 }}>{order.order_items.reduce((sum, item) => sum + ((item.product?.price || 0) * item.quantity), 0)} руб.</span>
                                                            <span style={{ fontWeight: 'bold', color: '#222' }}>{totalWithAllDiscounts.toLocaleString()} руб.</span>
                                                            <div style={{ color: '#0a0', fontSize: 12 }}>Скидка: {discountPercent}% (-{discountAmount.toLocaleString()} руб.)</div>
                                                        </td>
                                                        <td>
                                                            <Button
                                                                variant="success"
                                                                onClick={() => handleCompleteOrder(order.id)}
                                                                disabled={order.status === 'completed'}
                                                                size="sm"
                                                            >
                                                                Завершить
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                                {/* Мобильные карточки заказов */}
                                <div className="orders-table-mobile d-md-none">
                                    {Array.isArray(orders) && orders.map(order => {
                                        const totalWithProductDiscount = order.order_items.reduce(
                                            (sum, item) => sum + ((item.price_with_discount !== undefined && item.price_with_discount !== null
                                                ? Number(item.price_with_discount)
                                                : (item.product?.price || 0)) * item.quantity), 0
                                        );
                                        const discountPercent = Number(order.discount_percent) || 0;
                                        const discountAmount = discountPercent > 0 ? totalWithProductDiscount * discountPercent / 100 : 0;
                                        const totalWithAllDiscounts = totalWithProductDiscount - discountAmount;
                                        return (
                                            <div className="order-row" key={order.id}>
                                                <div className="order-header">
                                                    <span className="order-icon">📦</span>
                                                    <span style={{fontWeight:800}}>Заказ №{order.order_short_id}</span>
                                                </div>
                                                <hr className="order-divider" />
                                                <div>
                                                    <div className="order-label"><span className="order-icon">🗓️</span>Дата:</div>
                                                    <span className="order-value">{new Date(order.created_at).toLocaleString()}</span>
                                                </div>
                                                <div>
                                                    <div className="order-label"><span className="order-icon">👤</span>Пользователь:</div>
                                                    <span className="order-value">{order.user?.name || 'Гость'} ({order.user?.email || 'Нет email'})</span>
                                                </div>
                                                <div>
                                                    <div className="order-label"><span className="order-icon">🔄</span>Статус:</div>
                                                    <span className="order-value">
                                                        <Form.Select
                                                            style={{ display: 'inline-block', width: 'auto', minWidth: 120 }}
                                                            value={order.status}
                                                            onChange={e => handleStatusChange(order.id, e.target.value)}
                                                            disabled={order.status === 'completed'}
                                                            size="sm"
                                                        >
                                                            {statusOptions.map(opt => (
                                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                            ))}
                                                            {order.status === 'completed' && (
                                                                <option value="completed">Выполнен</option>
                                                            )}
                                                        </Form.Select>
                                                    </span>
                                                </div>
                                                <div className="order-items-list">
                                                    {(Array.isArray(order.order_items) ? order.order_items : []).map(item => (
                                                        <div className="order-item-row" key={item.id}>
                                                            <div className="order-item-header">
                                                                <span className="order-icon">🛒</span>
                                                                <span className="order-item-title">{item.product?.name}</span>
                                                            </div>
                                                            <div className="order-item-body">
                                                                {item.product?.image_url && (
                                                                    <img
                                                                        src={getImageUrl(item.product.image_url)}
                                                                        alt={item.product?.name}
                                                                        style={{width: 48, height: 48, objectFit: 'cover', borderRadius: 6, marginRight: 8, cursor: 'pointer'}} 
                                                                        onClick={() => setLightboxImg(getImageUrl(item.product.image_url))}
                                                                    />
                                                                )}
                                                                <div>
                                                                    <div><span className="order-label">Артикул:</span> <span className="order-value">{item.product?.shoe?.article || item.product?.clothes?.article || item.product?.article || '-'}</span></div>
                                                                    <div><span className="order-label">Размер:</span> <span className="order-value">{item.size?.value || '-'}</span></div>
                                                                    <div><span className="order-label">Цвет:</span> <span className="order-value">{item.color || item.variant?.color || '-'}</span></div>
                                                                    <div><span className="order-label">Кол-во:</span> <span className="order-value">{item.quantity}</span></div>
                                                                    <div><span className="order-label">Цена:</span> <div className="order-value">
                                                                        {(item.price_with_discount !== undefined && item.price_with_discount !== null && item.price_with_discount < (item.product?.price || 0)) ? (
                                                                            <>
                                                                                <span style={{textDecoration:'line-through',color:'#888',marginRight:6}}>{(item.product?.price || 0).toLocaleString()} руб.</span>
                                                                                <span style={{fontWeight:'bold',color:'#ff4757',fontSize:17}}>{Number(item.price_with_discount).toLocaleString()} руб.</span>
                                                                                <span style={{color:'#22c55e',fontSize:13,marginLeft:6}}>
                                                                                    -{Math.round(((item.product?.price || 0) - Number(item.price_with_discount)) / (item.product?.price || 1) * 100)}%
                                                                                </span>
                                                                            </>
                                                                        ) : (
                                                                            <span>{(item.product?.price || 0).toLocaleString()} руб.</span>
                                                                        )}
                                                                    </div></div>
                                                                </div>
                                                            </div>
                                                            <div className="order-item-actions">
                                                                <button
                                                                    className="order-delete-btn"
                                                                    onClick={() => handleRemoveItem(item.id)}
                                                                    disabled={order.status === 'completed'}
                                                                >
                                                                    <span className="order-icon">🗑️</span> Удалить
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <hr className="order-divider" />
                                                <div className="order-summary">
                                                    <div style={{fontWeight:'bold'}}>Сумма заказа: <span style={{ textDecoration: 'line-through', color: '#888', marginRight: 8 }}>{order.order_items.reduce((sum, item) => sum + ((item.product?.price || 0) * item.quantity), 0)} руб.</span>
                                                    <span style={{ fontWeight: 'bold', color: '#222' }}>{totalWithAllDiscounts.toLocaleString()} руб.</span></div>
                                                    <div style={{ color: '#0a0', fontSize: 14 }}>Скидка: {discountPercent}% (-{discountAmount.toLocaleString()} руб.)</div>
                                                </div>
                                                <div className="order-complete-btn-wrap">
                                                    <Button
                                                        variant="success"
                                                        onClick={() => handleCompleteOrder(order.id)}
                                                        disabled={order.status === 'completed'}
                                                        style={{width:'100%',marginTop:8}}
                                                    >
                                                        Завершить заказ
                                                    </Button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Card.Body>
                        </Card>
                    )}

                    {activeTab === 'products' && (
                        <Card>
                            <Card.Body>
                                <h3>Управление товарами</h3>
                                {showAddCategory && (
                                    <>
                                        <Card className="mb-3 p-3">
                                            <h5>Добавить категорию</h5>
                                            <Form>
                                                <Form.Group>
                                                    <Form.Label>Название категории</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        value={categoryName}
                                                        onChange={e => setCategoryName(e.target.value)}
                                                        placeholder="Введите название категории"
                                                    />
                                                </Form.Group>
                                                <Form.Group className="mt-3">
                                                    <Form.Label>Тип категории</Form.Label>
                                                    <Form.Select value={categoryType} onChange={e => setCategoryType(e.target.value)}>
                                                        <option value="shoe">Обувь</option>
                                                        <option value="toy">Игрушка</option>
                                                        <option value="clothes">Одежда</option>
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group className="mt-3">
                                                    <Form.Label>Родительская категория (необязательно)</Form.Label>
                                                    <Form.Select
                                                        value={categoryParentId || ''}
                                                        onChange={e => setCategoryParentId(e.target.value || '')}
                                                    >
                                                        <option value="">Без родителя (верхний уровень)</option>
                                                        {categories
                                                            .filter(cat => cat.type === categoryType)
                                                            .map(cat => (
                                                                <option key={cat.id} value={cat.id}>
                                                                    {cat.name}
                                                                </option>
                                                            ))}
                                                    </Form.Select>
                                                </Form.Group>
                                                {categoryError && <div style={{ color: 'red', marginTop: 5 }}>{categoryError}</div>}
                                                <div className="mt-3 d-flex gap-2">
                                                    <Button variant="secondary" onClick={() => setShowAddCategory(false)}>
                                                        Закрыть
                                                    </Button>
                                                    <Button variant="primary" onClick={() => setShowCategoryConfirm(true)}>
                                                        Добавить
                                                    </Button>
                                                </div>
                                            </Form>
                                        </Card>
                                        {/* Модальное окно подтверждения создания категории */}
                                        {showCategoryConfirm && (
                                          <Modal show centered onHide={() => setShowCategoryConfirm(false)}>
                                            <Modal.Header closeButton>
                                              <Modal.Title>Подтверждение</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                              Вы точно хотите создать категорию "{categoryName}" в "{categoryType === 'shoe' ? 'Обуви' : categoryType === 'toy' ? 'Игрушках' : 'Одежде'}"?
                                            </Modal.Body>
                                            <Modal.Footer>
                                              <Button variant="secondary" onClick={() => setShowCategoryConfirm(false)}>
                                                Отмена
                                              </Button>
                                              <Button variant="primary" onClick={() => { setShowCategoryConfirm(false); addCategory(); }}>
                                                Подтвердить
                                              </Button>
                                            </Modal.Footer>
                                          </Modal>
                                        )}
                                    </>
                                )}
                                <Form className="mb-4">
                                    <Form.Group className="mb-3">
                                        <Form.Label>Тип товара</Form.Label>
                                        <div>
                                            <Form.Check
                                                inline
                                                label="Обувь"
                                                type="radio"
                                                name="type"
                                                checked={type === 'shoe'}
                                                onChange={() => {
                                                    setType('shoe');
                                                    setSelectedCategory(null);
                                                }}
                                            />
                                            <Form.Check
                                                inline
                                                label="Игрушка"
                                                type="radio"
                                                name="type"
                                                checked={type === 'toy'}
                                                onChange={() => {
                                                    setType('toy');
                                                    setSelectedCategory(null);
                                                }}
                                            />
                                            <Form.Check
                                                inline
                                                label="Одежда"
                                                type="radio"
                                                name="type"
                                                checked={type === 'clothes'}
                                                onChange={() => {
                                                    setType('clothes');
                                                    setSelectedCategory(null);
                                                }}
                                            />
                                        </div>
                                    </Form.Group>
                                    <Row className="align-items-end mb-3 flex-wrap flex-md-nowrap">
                                        <Col xs={12} md={6} className="mb-2 mb-md-0">
                                            <Form.Group>
                                                <Form.Label>Категория</Form.Label>
                                                <div className="select-scroll-wrap">
                                                  <Form.Select
                                                      value={selectedCategory?.id ? String(selectedCategory.id) : ''}
                                                      onChange={e => {
                                                          const categoryId = e.target.value;
                                                          const category = categories.find(c => String(c.id) === categoryId && c.type === type);
                                                          setSelectedCategory(category || null);
                                                      }}
                                                  >
                                                      <option value="">Выберите категорию</option>
                                                      {categories
                                                          .filter(c => c.type === type)
                                                          .map(category => (
                                                              <option key={category.id} value={category.id} title={category.name}>{category.name}</option>
                                                          ))
                                                      }
                                                  </Form.Select>
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md="auto" className="d-flex justify-content-md-end justify-content-start">
                                            <Button variant="outline-primary" style={{ minWidth: 180 }} onClick={() => setShowAddCategory(true)}>
                                                Добавить категорию
                                            </Button>
                                        </Col>
                                    </Row>
                                    {/* Селектор магазинов для adminMain */}
                                    {user.role === 'main_admin' && (
                                        <Row className="mb-3">
                                            <Col xs={12} md={6}>
                                                <Form.Group>
                                                    <Form.Label>Магазин</Form.Label>
                                                    <div className="select-scroll-wrap">
                                                      <Form.Select
                                                          value={selectedStore}
                                                          onChange={e => setSelectedStore(e.target.value)}
                                                      >
                                                          <option value="">Выберите магазин</option>
                                                          {stores.map(store => (
                                                              <option key={store.id} value={store.id} title={store.name}>{store.name}</option>
                                                          ))}
                                                      </Form.Select>
                                                    </div>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    )}
                                    {/* Выбор магазина только для main_admin */}
                                    {user.role === 'main_admin' && (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Магазин для продажи</Form.Label>
                                            <div className="select-scroll-wrap">
                                              <Form.Select
                                                  value={selectedStore}
                                                  onChange={e => setSelectedStore(e.target.value)}
                                              >
                                                  <option value="">Выберите магазин</option>
                                                  {stores.map(store => (
                                                      <option key={store.id} value={store.id} title={store.name}>{store.name}</option>
                                                  ))}
                                              </Form.Select>
                                            </div>
                                        </Form.Group>
                                    )}
                                    <Form.Label>Название товара</Form.Label>
                                    <Form.Control
                                        value={name}
                                        onChange={e => setName(e.target.value)}
                                        className="mb-3"
                                        placeholder="Введите название товара"
                                    />
                                    {type === 'toy' && (
                                        <>
                                            <Form.Label>Штрих‑код (обязательно, если нет вариантов)</Form.Label>
                                            <Form.Control
                                                value={barcode}
                                                onChange={e => setBarcode(e.target.value)}
                                                className="mb-3"
                                                placeholder="Введите штрих‑код игрушки"
                                                required={!variants.length}
                                                isInvalid={!variants.length && !barcode}
                                            />
                                            <Form.Label>Материал</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={material}
                                                onChange={e => setMaterial(e.target.value)}
                                                className="mb-3"
                                                placeholder="Введите материал игрушки (необязательно)"
                                            />
                                            <Form.Label>Возрастные ограничения</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={ageRating}
                                                onChange={e => setAgeRating(e.target.value)}
                                                className="mb-3"
                                                placeholder="Введите возрастные ограничения (необязательно)"
                                            />
                                            <Alert variant="info" className="py-2 mb-2">
                                                Добавьте варианты игрушки (название, количество, штрих‑код, артикул?, магазин). Если варианты не добавить, будет использован старый способ: одно количество и штрих‑код.
                                            </Alert>
                                            <Row className="align-items-end mb-3">
                                                <Col md={3}>
                                                    <Form.Label>Название варианта</Form.Label>
                                                    <Form.Control
                                                        value={newVariant.name || ''}
                                                        onChange={e => setNewVariant({ ...newVariant, name: e.target.value })}
                                                        placeholder="Напр. Цвет/упаковка"
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Label>Количество</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min={1}
                                                        value={newVariant.quantity || 1}
                                                        onChange={e => setNewVariant({ ...newVariant, quantity: Math.max(1, Number(e.target.value)) })}
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Label>Штрих‑код</Form.Label>
                                                    <Form.Control
                                                        value={newVariant.barcode || ''}
                                                        onChange={e => setNewVariant({ ...newVariant, barcode: e.target.value })}
                                                        placeholder="Штрих‑код (необязательно)"
                                                    />
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Label>Артикул</Form.Label>
                                                    <Form.Control
                                                        value={newVariant.article || ''}
                                                        onChange={e => setNewVariant({ ...newVariant, article: e.target.value })}
                                                        placeholder="Артикул (необязательно)"
                                                    />
                                                </Col>
                                                {user.role === 'main_admin' && (
                                                    <Col md={3}>
                                                        <Form.Label>Магазин</Form.Label>
                                                        <div className="select-scroll-wrap">
                                                            <Form.Select
                                                                value={newVariant.storeId || ''}
                                                                onChange={e => setNewVariant({ ...newVariant, storeId: e.target.value })}
                                                            >
                                                                <option value="">Выберите магазин</option>
                                                                {stores.map(store => (
                                                                    <option key={store.id} value={store.id} title={store.name}>{store.name}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </div>
                                                    </Col>
                                                )}
                                                <Col md={12} className="mt-2">
                                                    <Button variant="success" onClick={handleAddVariant}>Добавить вариант</Button>
                                                </Col>
                                            </Row>
                                            {variants.length > 0 && (
                                              <Table bordered size="sm" className="mb-3">
                                                <thead>
                                                  <tr>
                                                    <th>Название</th>
                                                    <th>Кол-во</th>
                                                    <th>Штрих‑код</th>
                                                    <th>Артикул</th>
                                                    {user.role === 'main_admin' && <th>Магазин</th>}
                                                    {user.role === 'store_admin' && <th>Магазин</th>}
                                                    <th></th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {variants.map((v, idx) => (
                                                    <tr key={idx}>
                                                      <td><Form.Control value={v.name || ''} onChange={e => handleVariantChange(idx, 'name', e.target.value)} /></td>
                                                      <td><Form.Control type="number" min={0} value={v.quantity || 0} onChange={e => handleVariantChange(idx, 'quantity', Math.max(0, Number(e.target.value)))} /></td>
                                                      <td><Form.Control value={v.barcode || ''} onChange={e => handleVariantChange(idx, 'barcode', e.target.value)} /></td>
                                                      <td><Form.Control value={v.article || ''} onChange={e => handleVariantChange(idx, 'article', e.target.value)} /></td>
                                                      {user.role === 'main_admin' && (
                                                        <td>
                                                          <div className="select-scroll-wrap">
                                                            <Form.Select
                                                              value={v.storeId || selectedStore}
                                                              onChange={e => handleVariantChange(idx, 'storeId', e.target.value)}
                                                            >
                                                              <option value="">Выберите магазин</option>
                                                              {stores.map(store => (
                                                                <option key={store.id} value={store.id} title={store.name}>{store.name}</option>
                                                              ))}
                                                            </Form.Select>
                                                          </div>
                                                        </td>
                                                      )}
                                                      {user.role === 'store_admin' && (
                                                        <td>
                                                          {stores.find(s => s.id === v.storeId)?.name || 'Не указан'}
                                                        </td>
                                                      )}
                                                      <td><Button size="sm" variant="danger" onClick={() => handleRemoveVariant(idx)}>×</Button></td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </Table>
                                            )}
                                        </>
                                    )}
                                    {type === 'clothes' && (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Материал</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={material}
                                                onChange={e => setMaterial(e.target.value)}
                                                placeholder="Введите материал одежды (необязательно)"
                                            />
                                        </Form.Group>
                                    )}
                                    {(type === 'shoe' || type === 'clothes') && null}
                                    <Form.Label>Описание товара</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        value={description}
                                        onChange={e => setDescription(e.target.value)}
                                        className="mb-3"
                                        placeholder="Введите описание товара"
                                    />
                                    {type === 'shoe' && (
                                        <>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Пол</Form.Label>
                                                <div>
                                                    <Form.Check
                                                        inline
                                                        label="Мужской"
                                                        type="radio"
                                                        name="genderOptionsAdd"
                                                        id="gender-male-add"
                                                        value="мужской"
                                                        checked={gender === 'мужской'}
                                                        onChange={e => setGender(e.target.value)}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Женский"
                                                        type="radio"
                                                        name="genderOptionsAdd"
                                                        id="gender-female-add"
                                                        value="женский"
                                                        checked={gender === 'женский'}
                                                        onChange={e => setGender(e.target.value)}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Артикул</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={article}
                                                    onChange={e => setArticle(e.target.value)}
                                                    placeholder="Введите артикул обуви"
                                                />
                                            </Form.Group>
                                        </>
                                    )}
                                    {type === 'clothes' && (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Артикул</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={article}
                                                onChange={e => setArticle(e.target.value)}
                                                placeholder="Введите артикул одежды"
                                            />
                                        </Form.Group>
                                    )}
                                    <Form.Label>Цена</Form.Label>
                                    <Form.Control
                                        type="number"
                                        min={0}
                                        value={price}
                                        onChange={e => setPrice(Math.max(0, Number(e.target.value)))}
                                        className="mb-3"
                                        placeholder="Введите цену товара"
                                    />
                                    <Form.Label>Изображения</Form.Label>
                                    <Form.Group className="mb-3">
                                      <Form.Label>Фотографии</Form.Label>
                                      <div {...dragEvents}>
                                        <div>Перетащите изображения сюда или кликните для выбора</div>
                                        <input
                                          type="file"
                                          multiple
                                          accept="image/*"
                                          style={{ display: 'none' }}
                                          ref={fileInputRef}
                                          onChange={handleFileChange}
                                        />
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 12 }}>
                                          {images.map((img, idx) => (
                                            <div key={idx} style={{ position: 'relative' }}>
                                              <img src={img.url} alt="preview" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 6, border: '1px solid #ccc' }} />
                                              <Button size="sm" variant="danger" style={{ position: 'absolute', top: 2, right: 2, padding: '0 6px', borderRadius: '50%' }} onClick={e => { e.stopPropagation(); handleRemoveImage(idx); }}>×</Button>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    </Form.Group>
                                    {(type === 'shoe' || type === 'clothes') && (
                                        <>
                                            <Form.Label>Добавить вариант (размер+цвет+количество+штрих-код)</Form.Label>
                                            <Row className="align-items-end">
                                                <Col md={3}>
                                                    <Form.Label>Размер</Form.Label>
                                                    <Form.Control
                                                        list="available-sizes-list"
                                                        value={variantSize}
                                                        onChange={e => setVariantSize(e.target.value)}
                                                        placeholder="Введите или выберите размер"
                                                        autoComplete="off"
                                                    />
                                                    <datalist id="available-sizes-list">
                                                        {availableSizes.map(size => (
                                                            <option key={size.id} value={size.value} />
                                                        ))}
                                                    </datalist>
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Label>Цвет</Form.Label>
                                                    <Form.Control value={variantColor} onChange={e => setVariantColor(e.target.value)} placeholder="Цвет" />
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Label>Количество</Form.Label>
                                                    <Form.Control type="number" min={1} value={variantQuantity} onChange={e => setVariantQuantity(Math.max(1, e.target.value))} />
                                                </Col>
                                                <Col md={3}>
                                                    <Form.Label>Штрих-код</Form.Label>
                                                    <Form.Control value={variantBarcode} onChange={e => setVariantBarcode(e.target.value)} placeholder="Штрих-код" />
                                                </Col>
                                                <Col md={12} className="mt-2">
                                                    <Button variant="success" onClick={handleAddVariant}>Добавить</Button>
                                                </Col>
                                            </Row>
                                            {variants.length > 0 && (
                                                <Table bordered size="sm" className="mt-3">
                                                    <thead>
                                                        <tr>
                                                            <th>Размер</th>
                                                            <th>Цвет</th>
                                                            <th>Количество</th>
                                                            <th>Штрих-код</th>
                                                            {user.role === 'main_admin' && <th>Магазин</th>}
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(Array.isArray(variants) ? variants : []).map((v, idx) => (
                                                            <tr key={idx}>
                                                                <td>
                                                                    <Form.Control 
                                                                        value={v.size || ''} 
                                                                        onChange={e => handleVariantChange(idx, 'size', e.target.value)} 
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Form.Control 
                                                                        value={v.color || ''} 
                                                                        onChange={e => handleVariantChange(idx, 'color', e.target.value)} 
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Form.Control 
                                                                        type="number" 
                                                                        min={0} 
                                                                        value={v.quantity || 0} 
                                                                        onChange={e => handleVariantChange(idx, 'quantity', Math.max(0, Number(e.target.value)))} 
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <Form.Control 
                                                                        value={v.barcode || ''} 
                                                                        onChange={e => handleVariantChange(idx, 'barcode', e.target.value)} 
                                                                    />
                                                                </td>
                                                                {user.role === 'main_admin' && (
                                                                    <td>
                                                                        <div className="select-scroll-wrap">
                                                                            <Form.Select
                                                                                value={v.storeId || selectedStore}
                                                                                onChange={e => handleVariantChange(idx, 'storeId', e.target.value)}
                                                                            >
                                                                                <option value="">Выберите магазин</option>
                                                                                {stores.map(store => (
                                                                                    <option key={store.id} value={store.id} title={store.name}>{store.name}</option>
                                                                                ))}
                                                                            </Form.Select>
                                                                        </div>
                                                                    </td>
                                                                )}
                                                                <td><Button variant="danger" size="sm" onClick={() => handleRemoveVariant(idx)}>Удалить</Button></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            )}
                                        </>
                                    )}
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={addProduct}
                                      disabled={isLoading}
                                      style={{ minWidth: 120 }}
                                    >
                                      {isLoading ? (
                                        <>
                                          <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                          Сохраняем...
                                        </>
                                      ) : (
                                        'Добавить товар'
                                      )}
                                    </button>
                                </Form>
                                <hr />
                                {/* Модальные окна для редактирования и удаления ВЫНЕСЕНЫ ИЗ ФОРМЫ */}
                                <EditProductModal
                                    show={editModalVisible}
                                    onHide={handleEditProductModalClose}
                                    productId={editProductId}
                                    onSave={handleEditProductSave}
                                    restoreFocus={false}
                                />
                                <DeleteProductModal
                                    show={deleteProductVisible}
                                    onHide={() => setDeleteProductVisible(false)}
                                    product={productToDelete}
                                    onDeleted={handleProductDeleted}
                                />
                                <h4>Список товаров</h4>
                                <div className="mb-3 d-flex flex-wrap align-items-center" style={{ gap: '1rem' }}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Поиск по названию, артикулу или штрих-коду..."
                                        value={productSearch}
                                        onChange={e => setProductSearch(e.target.value)}
                                        style={{ maxWidth: 300 }}
                                    />
                                    <Form.Select
                                        value={productTypeFilter}
                                        onChange={e => setProductTypeFilter(e.target.value)}
                                        style={{ maxWidth: 160 }}
                                    >
                                        <option value="">Все типы</option>
                                        <option value="shoe">Обувь</option>
                                        <option value="clothes">Одежда</option>
                                        <option value="toy">Игрушки</option>
                                    </Form.Select>
                                    <Button
                                        size="sm"
                                        variant="outline-secondary"
                                        onClick={() => setProductSortDirection(productSortDirection === 'asc' ? 'desc' : 'asc')}
                                        style={{ minWidth: 180 }}
                                    >
                                        Сортировать по количеству {productSortDirection === 'asc' ? '↑' : '↓'}
                                    </Button>
                                    {user.role === 'main_admin' && (
                                      <>
                                        <Button
                                          size="sm"
                                          variant="outline-warning"
                                          onClick={async () => {
                                            if (!window.confirm('Пересчитать количество для всех товаров?')) return;
                                            try {
                                              const result = await recalculateAllProductQuantities();
                                              showToast(`Обновлено товаров: ${result?.fixed ?? 0}`, 'success');
                                              await loadProducts();
                                            } catch (e) {
                                              showToast(e?.response?.data?.message || 'Ошибка при обновлении остатков товаров', 'error');
                                            }
                                          }}
                                          style={{ minWidth: 240, marginRight: 8 }}
                                        >
                                          Обновить все товары
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="outline-danger"
                                          onClick={async () => {
                                            if (!window.confirm('Удалить все товары с общим количеством = 0?')) return;
                                            try {
                                              const result = await deleteZeroStockProducts();
                                              showToast(`Удалено товаров: ${result?.deleted ?? 0}`, 'success');
                                              await loadProducts();
                                              // Заберём бэкенд-логи операции и выведем в консоль для диагностики
                                              try {
                                                const logsRes = await $authHost.get('/api/product/bulk/zero-stock/logs');
                                                const logs = Array.isArray(logsRes?.data) ? logsRes.data : [];
                                                // eslint-disable-next-line no-console
                                                console.table(logs);
                                              } catch (e) {}
                                            } catch (e) {
                                              showToast(e?.response?.data?.message || 'Ошибка при удалении товаров с нулевым остатком', 'error');
                                            }
                                          }}
                                          style={{ minWidth: 240 }}
                                        >
                                          Удалить товары с количеством 0
                                        </Button>
                                      </>
                                    )}
                                </div>
                                {loadingProducts && <Spinner animation="border" />}
                                {productsError && <div className="text-danger mb-2">{productsError}</div>}
                                <div className="table-responsive mb-3">
                                    <Table bordered size="sm" className="align-middle text-nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: 120 }}>Название</th>
                                                <th style={{ minWidth: 120 }}>Категория</th>
                                                <th style={{ minWidth: 120 }}>Магазин</th>
                                                <th style={{ minWidth: 90 }}>Артикул</th>
                                                <th style={{ minWidth: 90 }}>Тип</th>
                                                <th style={{ minWidth: 90 }}>Цвет</th>
                                                <th style={{ minWidth: 90 }}>Цена</th>
                                                <th
                                                  style={{ cursor: 'pointer', userSelect: 'none' }}
                                                  onClick={() => setProductSortDirection(productSortDirection === 'asc' ? 'desc' : 'asc')}
                                                >
                                                  Количество {productSortDirection === 'asc' ? '↑' : '↓'}
                                                </th>
                                                <th style={{ minWidth: 160 }}>Действия</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paginatedProducts.map(product => {
                                              let colorStr = '-';
                                              if (product.type === 'shoe' || product.type === 'clothes') {
                                                const colors = (product.variants || []).map(v => v.color).filter(Boolean);
                                                colorStr = colors.length > 0 ? [...new Set(colors)].map(getColorName).join(', ') : '-';
                                              } else if (product.type === 'toy') {
                                                colorStr = getColorName(product.color);
                                              }
                                              const quantity = getProductQuantity(product);
                                              return (
                                                <tr key={product.id}>
                                                  <td>{product.name}</td>
                                                  <td>{product.category?.name}</td>
                                                  <td>{(Array.isArray(product.stores) ? product.stores : []).map(s => s.name).join(', ')}</td>
                                                  <td>{product.article || product.clothes?.article || '-'}</td>
                                                  <td>{product.type}</td>
                                                  <td>{colorStr}</td>
                                                  <td>{product.price}</td>
                                                  <td>{quantity}</td>
                                                  <td className="d-flex flex-wrap gap-2">
                                                    <Button
                                                      ref={el => editButtonRefs.current[product.id] = el}
                                                      tabIndex={editButtonTabIndex[product.id] ?? 0}
                                                      onClick={e => handleUpdateProduct(product, e)}
                                                    >
                                                      Изменить
                                                    </Button>
                                                    <Button size="sm" variant="outline-danger" onClick={() => handleDeleteProduct(product)}>
                                                      Удалить
                                                    </Button>
                                                  </td>
                                                </tr>
                                              );
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                                {/* Мобильные карточки */}
                                <div className="products-table-mobile d-md-none">
                                    {paginatedProducts.map(product => {
                                      let colorStr = '-';
                                      if (product.type === 'shoe' || product.type === 'clothes') {
                                        const colors = (product.variants || []).map(v => v.color).filter(Boolean);
                                        colorStr = colors.length > 0 ? [...new Set(colors)].map(getColorName).join(', ') : '-';
                                      } else if (product.type === 'toy') {
                                        colorStr = getColorName(product.color);
                                      }
                                      const quantity = getProductQuantity(product);
                                      return (
                                        <div className="product-row" key={product.id}>
                                          <div className="product-header">
                                            <span className="product-icon">📦</span>
                                            <span>{product.name}</span>
                                          </div>
                                          <hr className="product-divider" />
                                          <div>
                                            <div className="product-label"><span className="product-icon">🏷️</span>Категория:</div>
                                            <span className="product-value">{product.category?.name || '-'}</span>
                                          </div>
                                          <div>
                                            <div className="product-label"><span className="product-icon">🏪</span>Магазин:</div>
                                            <span className="product-value">{(Array.isArray(product.stores) ? product.stores : []).map(s => s.name).join(', ') || '-'}</span>
                                          </div>
                                          <div>
                                            <div className="product-label"><span className="product-icon">🔖</span>Артикул:</div>
                                            <span className="product-value">{product.article || product.clothes?.article || '-'}</span>
                                          </div>
                                          <div>
                                            <div className="product-label"><span className="product-icon">📋</span>Тип:</div>
                                            <span className="product-value">{product.type}</span>
                                          </div>
                                          <div>
                                            <div className="product-label"><span className="product-icon">🎨</span>Цвет:</div>
                                            <span className="product-value">{colorStr}</span>
                                          </div>
                                          <div>
                                            <div className="product-label"><span className="product-icon">💸</span>Цена:</div>
                                            <span className="product-value">{product.price} ₽</span>
                                          </div>
                                          <div>
                                            <div className="product-label"><span className="product-icon">💰</span>Остаток:</div>
                                            <span className="product-value">{quantity}</span>
                                          </div>
                                          <div className="product-actions">
                                            <button
                                              className="product-edit-btn"
                                              ref={el => editButtonRefs.current[product.id] = el}
                                              tabIndex={editButtonTabIndex[product.id] ?? 0}
                                              onClick={e => handleUpdateProduct(product, e)}
                                            >
                                              <span className="product-icon">✏️</span> Изменить
                                            </button>
                                            <button
                                              className="product-delete-btn"
                                              onClick={() => handleDeleteProduct(product)}
                                            >
                                              <span className="product-icon">🗑️</span> Удалить
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                                {sortedProducts.length > visibleProductsCount && (
                                    <div className="text-center mb-3">
                                        <Button
                                            variant="outline-primary"
                                            onClick={() => setVisibleProductsCount(prev => prev + 20)}
                                        >
                                            Загрузить ещё
                                        </Button>
                                    </div>
                                )}
                                {user.role === 'main_admin' && (
                                  <Card className="mb-3 p-3">
                                    <h5>Управление категориями</h5>
                                    <Table bordered size="sm">
                                      <thead>
                                        <tr>
                                          <th>Название</th>
                                          <th>Тип</th>
                                          <th>Действия</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {categories.map(cat => (
                                          <tr key={cat.id}>
                                            <td>{cat.name}</td>
                                            <td>{cat.type}</td>
                                            <td>
                                              <Button
                                                size="sm"
                                                variant="outline-success"
                                                onClick={() => handleOpenCategoryDiscount(cat)}
                                                className="me-2"
                                              >
                                                Скидка
                                              </Button>
                                              <Button
                                                size="sm"
                                                variant="outline-primary"
                                                onClick={() => handleEditCategory(cat)}
                                                className="me-2"
                                              >
                                                Изменить
                                              </Button>
                                              <Button
                                                size="sm"
                                                variant="outline-danger"
                                                onClick={() => handleDeleteCategory(cat)}
                                              >
                                                Удалить
                                              </Button>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  </Card>
                                )}
                            </Card.Body>
                        </Card>
                    )}

                    {activeTab === 'sales' && (
                        <Card>
                            <Card.Body>
                                <h3>История продаж</h3>
                                {/* Для main_admin — выбор магазина */}
                                {user.role === 'main_admin' && (
                                    <Form.Group className="mb-3" style={{maxWidth: 320}}>
                                        <Form.Label>Магазин</Form.Label>
                                        <Form.Select
                                            value={selectedSalesStore}
                                            onChange={e => setSelectedSalesStore(e.target.value)}
                                        >
                                            <option value="">Все магазины</option>
                                            {stores.map(store => (
                                                <option key={store.id} value={store.id}>{store.name}</option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>
                                )}
                                <div className="mb-3" style={{ marginBottom: '1.25rem' }}>
                                    <Button
                                        variant="success"
                                        className="w-100 w-md-auto"
                                        style={{ minWidth: 180, marginBottom: '0.5rem' }}
                                        onClick={() => setShowSaleForm(true)}
                                    >
                                        Оформить продажу
                                    </Button>
                                </div>
                                <div className="d-flex flex-wrap flex-md-nowrap align-items-center mb-3" style={{ gap: '1rem' }}>
                                    <Form.Select
                                        value={salesSort}
                                        onChange={e => setSalesSort(e.target.value)}
                                        style={{ maxWidth: 220, marginRight: '0.5rem' }}
                                    >
                                        <option value="date_desc">Сначала новые</option>
                                        <option value="date_asc">Сначала старые</option>
                                    </Form.Select>
                                    <Form className="d-flex flex-wrap flex-md-nowrap align-items-center mb-0" style={{ gap: '0.75rem' }}>
                                        <Form.Select value={salesMode} onChange={e => setSalesMode(e.target.value)} style={{ maxWidth: 100 }}>
                                            <option value="day">День</option>
                                            <option value="month">Месяц</option>
                                        </Form.Select>
                                        {salesMode === 'day' ? (
                                            <Form.Control type="date" value={salesDate} onChange={e => setSalesDate(e.target.value)} style={{ maxWidth: 180 }} />
                                        ) : (
                                            <>
                                                <Form.Control type="number" min={2020} max={2100} value={salesYear} onChange={e => setSalesYear(e.target.value)} style={{ maxWidth: 100 }} />
                                                <Form.Select value={salesMonth} onChange={e => setSalesMonth(e.target.value)} style={{ maxWidth: 100 }}>
                                                    {[...Array(12)].map((_, i) => (
                                                        <option key={i+1} value={i+1}>{i+1}</option>
                                                    ))}
                                                </Form.Select>
                                            </>
                                        )}
                                        <Button onClick={fetchSales} style={{ minWidth: 100 }}>
                                            Показать
                                        </Button>
                                    </Form>
                                </div>
                                {loadingSales && <Spinner animation="border" />}
                                {salesError && <div className="text-danger mb-2">{salesError}</div>}
                                {Array.isArray(filteredSales) && filteredSales.length === 0 && !loadingSales && <div>Нет продаж за выбранный период.</div>}
                                {Array.isArray(filteredSales) && filteredSales.length > 0 && (
                                    <>
                                        {/* Обычная таблица для десктопа */}
                                        <Table bordered size="sm" className="d-none d-md-table sales-table">
                                            <thead>
                                                <tr>
                                                    <th>№ заказа</th>
                                                    <th>Фото</th>
                                                    <th>Товар</th>
                                                    <th>Артикул</th>
                                                    <th>Размер</th>
                                                    <th>Цена</th>
                                                    <th>Оплата</th>
                                                    <th>Дата и время</th>
                                                    <th>Действия</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(Array.isArray(visibleSales) ? visibleSales : []).map((sale, idx) => (
                                                    <tr key={idx}>
                                                        <td>{sale.orderNum}</td>
                                                        <td>
                                                            {sale.image_url ? (
                                                                <img
                                                                    src={getImageUrl(sale.image_url)}
                                                                    alt={sale.product}
                                                                    style={{width: 48, height: 48, objectFit: 'cover', borderRadius: 6, cursor: 'pointer'}}
                                                                    onClick={() => setLightboxImg(getImageUrl(sale.image_url))}
                                                                    loading="lazy"
                                                                />
                                                            ) : (
                                                                <span style={{color: '#999'}}>—</span>
                                                            )}
                                                        </td>
                                                        <td>{sale.product}</td>
                                                        <td>{sale.article || '-'}</td>
                                                        <td>{sale.variantName || sale.size || '-'}</td>
                                                        <td>{sale.price} ₽</td>
                                                        <td>
                                                            <span style={{
                                                                padding: '4px 8px',
                                                                borderRadius: '4px',
                                                                fontSize: '0.85em',
                                                                backgroundColor: sale.paymentType === 'card' ? '#e3f2fd' : '#fff3e0',
                                                                color: sale.paymentType === 'card' ? '#1976d2' : '#e65100'
                                                            }}>
                                                                {sale.paymentType === 'card' ? '💳 Карта' : '💵 Наличные'}
                                                            </span>
                                                        </td>
                                                        <td>{sale.dateTime}</td>
                                                        <td>
                                                            {!sale.isReturned && (
                                                                <Button
                                                                    variant="danger"
                                                                    size="sm"
                                                                    onClick={() => handleReturnSale(sale)}
                                                                >
                                                                    Удалить
                                                                </Button>
                                                            )}
                                                            {sale.isReturned && <span className="text-success">Возвращено</span>}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        {/* Мобильные карточки */}
                                        <div className="sales-table-mobile d-md-none">
                                            {(Array.isArray(visibleSales) ? visibleSales : []).map((sale, idx) => (
                                                <div className={`sales-row${sale.isReturned ? ' returned' : ''}`} key={idx}>
                                                    <div className="sales-header">
                                                        <span className="sales-icon" style={{fontSize:'1.4em'}}>🧾</span>
                                                        <span>№ {sale.orderNum}</span>
                                                        {sale.isReturned
                                                          ? <span className="sales-status-badge">Возвращено</span>
                                                          : <span className="sales-status-badge" style={{background:'linear-gradient(90deg,#2563eb 0%,#38bdf8 100%)',color:'#fff'}}>Продано</span>
                                                        }
                                                    </div>
                                                    <hr className="sales-divider" />
                                                    {/* === FIX: Добавляем фото товара === */}
                                                    {sale.image_url && (
                                                        <div style={{marginBottom: '12px', textAlign: 'center'}}>
                                                            <img
                                                                src={getImageUrl(sale.image_url)}
                                                                alt={sale.product}
                                                                style={{
                                                                    width: 80,
                                                                    height: 80,
                                                                    objectFit: 'cover',
                                                                    borderRadius: 8,
                                                                    cursor: 'pointer',
                                                                    border: '1px solid #ddd'
                                                                }}
                                                                onClick={() => setLightboxImg(getImageUrl(sale.image_url))}
                                                                loading="lazy"
                                                            />
                                                        </div>
                                                    )}
                                                    <div>
                                                        <div className="sales-label"><span className="sales-icon">📦</span>Товар:</div>
                                                        <span className="sales-value">{sale.product}</span>
                                                    </div>
                                                    <div>
                                                        <div className="sales-label"><span className="sales-icon">🔖</span>Артикул:</div>
                                                        <span className="sales-value">{sale.article || '-'}</span>
                                                    </div>
                                                    <div>
                                                        <div className="sales-label"><span className="sales-icon">📏</span>Размер:</div>
                                                        <span className="sales-value">{sale.variantName || sale.size || '-'}</span>
                                                    </div>
                                                    <hr className="sales-divider" />
                                                    <div>
                                                        <div className="sales-label"><span className="sales-icon">💸</span>Цена:</div>
                                                        <span className="sales-value">{sale.price} ₽</span>
                                                    </div>
                                                    <div>
                                                        <div className="sales-label"><span className="sales-icon">{sale.paymentType === 'card' ? '💳' : '💵'}</span>Оплата:</div>
                                                        <span className="sales-value" style={{
                                                            padding: '4px 8px',
                                                            borderRadius: '4px',
                                                            fontSize: '0.9em',
                                                            backgroundColor: sale.paymentType === 'card' ? '#e3f2fd' : '#fff3e0',
                                                            color: sale.paymentType === 'card' ? '#1976d2' : '#e65100',
                                                            display: 'inline-block'
                                                        }}>
                                                            {sale.paymentType === 'card' ? 'Карта' : 'Наличные'}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        <div className="sales-label"><span className="sales-icon">🕒</span>Дата и время:</div>
                                                        <span className="sales-value">{sale.dateTime}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        {Array.isArray(filteredSales) && filteredSales.length > visibleSalesCount && (
                                            <div className="text-center mt-3">
                                                <Button
                                                    variant="outline-primary"
                                                    onClick={() => setVisibleSalesCount(prev => prev + 20)}
                                                >
                                                    Загрузить ещё
                                                </Button>
                                            </div>
                                        )}
                                        {/* Итоги по выбранному магазину */}
                                        {(() => {
                                            let totalCash = 0;
                                            let totalCard = 0;
                                            let total = 0;
                                            (Array.isArray(filteredSales) ? filteredSales.filter(sale => !sale.isReturned) : []).forEach(sale => {
                                                const price = Number(sale.total || sale.price || 0);
                                                if (sale.paymentType === 'card') totalCard += price;
                                                else totalCash += price;
                                                total += price;
                                            });
                                            return (
                                                <div className="text-end mt-3">
                                                    <h5>Итого наличными: {totalCash} ₽</h5>
                                                    <h5>Итого по карте: {totalCard} ₽</h5>
                                                    <h4>Общая сумма за период: {total} ₽</h4>
                                                </div>
                                            );
                                        })()}
                                    </>
                                )}
                                {showSaleForm && (
                                  <Modal
                                    show={true}
                                    onHide={handleCloseSaleForm}
                                    size="lg"
                                    centered
                                    dialogClassName="sale-modal"
                                    backdrop="static"
                                    keyboard={false}
                                  >
                                    <Modal.Header closeButton>
                                        <Modal.Title>Продажа товара</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        {/* Новое поле для barcode */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>Штрих-код пользователя (для персональной скидки)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={userBarcode}
                                                onChange={e => setUserBarcode(e.target.value)}
                                                onBlur={handleUserBarcodeBlur}
                                                placeholder="Отсканируйте или введите штрих-код пользователя"
                                                isInvalid={!!userDiscountError}
                                            />
                                            {userDiscountError && <div className="text-danger mt-1">{userDiscountError}</div>}
                                            {userFound && (
                                                <div className="text-success mt-1">Пользователь: {userFound.name || userFound.email} | Персональная скидка: {userDiscount}%</div>
                                            )}
                                        </Form.Group>
                                        {/* Старое поле email, делаем неактивным если найден по barcode */}
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email пользователя (для персональной скидки)</Form.Label>
                                            <Form.Control
                                                type="email"
                                                value={userEmail}
                                                onChange={e => setUserEmail(e.target.value)}
                                                onBlur={handleUserEmailBlur}
                                                placeholder="Введите email пользователя"
                                                isInvalid={!!userDiscountError}
                                                disabled={!!userFound}
                                            />
                                            {userDiscountError && <div className="text-danger mt-1">{userDiscountError}</div>}
                                            {userFound && (
                                                <div className="text-success mt-1">Персональная скидка пользователя: {userDiscount}%</div>
                                            )}
                                        </Form.Group>
                                        <Form onSubmit={handleBarcodeSubmit}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Штрих-код товара</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    value={barcode}
                                                    onChange={(e) => setBarcode(e.target.value)}
                                                    placeholder="Отсканируйте или введите штрих-код"
                                                    autoFocus
                                                />
                                            </Form.Group>
                                            <Button type="submit" variant="primary" className="mb-3">
                                                Найти товар
                                            </Button>
                                        </Form>
                                        {saleError && <div className="text-danger mb-3">{saleError}</div>}
                                        {currentProduct && (
                                            <div className="mb-3">
                                                <h5>Найденный товар:</h5>
                                                <p>Название: {currentProduct.name}</p>
                                                <p>Цена: {foundVariants.length > 0 && selectedVariantIdx >= 0 && foundVariants[selectedVariantIdx]?.price_with_discount < foundVariants[selectedVariantIdx]?.price ? (
                                                  <>
                                                    <span style={{textDecoration:'line-through',color:'#888',marginRight:6}}>{foundVariants[selectedVariantIdx]?.price?.toLocaleString()} ₽</span>
                                                    <span style={{fontWeight:'bold',color:'#ff4757',fontSize:17}}>{foundVariants[selectedVariantIdx]?.price_with_discount?.toLocaleString()} ₽</span>
                                                    <span style={{color:'#22c55e',fontSize:13,marginLeft:6}}>
                                                      -{Math.round(100 - (foundVariants[selectedVariantIdx]?.price_with_discount / foundVariants[selectedVariantIdx]?.price) * 100)}%
                                                    </span>
                                                  </>
                                                ) : (currentProduct.discount > 0 && currentProduct.price_with_discount < currentProduct.price ? (
                                                  <>
                                                    <span style={{textDecoration:'line-through',color:'#888',marginRight:6}}>{currentProduct.price?.toLocaleString()} ₽</span>
                                                    <span style={{fontWeight:'bold',color:'#ff4757',fontSize:17}}>{currentProduct.price_with_discount?.toLocaleString()} ₽</span>
                                                    <span style={{color:'#22c55e',fontSize:13,marginLeft:6}}>
                                                      -{Math.round(100 - (currentProduct.price_with_discount / currentProduct.price) * 100)}%
                                                    </span>
                                                  </>
                                                ) : (
                                                  <span>{currentProduct.price?.toLocaleString()} ₽</span>
                                                ))}</p>
                                                {currentProduct.type === 'toy' && (
                                                  <Form.Group className="mb-3">
                                                    <Form.Label>Количество</Form.Label>
                                                    {(() => {
                                                      // Определяем количество выбранного варианта
                                                      let availableQuantity = 0;
                                                      if (foundVariants.length > 0 && selectedVariantIdx >= 0) {
                                                        availableQuantity = foundVariants[selectedVariantIdx]?.quantity || 0;
                                                      } else if (foundVariants.length === 1) {
                                                        availableQuantity = foundVariants[0]?.quantity || 0;
                                                      } else {
                                                        availableQuantity = currentProduct.product_stores?.[0]?.quantity || currentProduct.toy?.quantity || currentProduct.stock || 0;
                                                      }
                                                      return (
                                                        <div style={{display:'flex',alignItems:'center',gap:8}}>
                                                          <Button
                                                            variant="outline-secondary"
                                                            size="sm"
                                                            onClick={() => setToyQuantity(q => Math.max(1, q - 1))}
                                                            disabled={toyQuantity <= 1}
                                                            tabIndex={0}
                                                            aria-label="Уменьшить количество"
                                                          >-</Button>
                                                          <Form.Control
                                                            type="number"
                                                            min={1}
                                                            max={availableQuantity}
                                                            value={toyQuantity}
                                                            onChange={e => setToyQuantity(Math.max(1, Math.min(Number(e.target.value), availableQuantity)))}
                                                            style={{width:60,textAlign:'center'}}
                                                            disabled={availableQuantity === 0}
                                                          />
                                                          <Button
                                                            variant="outline-secondary"
                                                            size="sm"
                                                            onClick={() => setToyQuantity(q => Math.min(q + 1, availableQuantity))}
                                                            disabled={toyQuantity >= availableQuantity}
                                                            tabIndex={0}
                                                            aria-label="Увеличить количество"
                                                          >+</Button>
                                                          <div style={{fontSize:'12px',color:availableQuantity === 0 ? '#f00' : '#888',marginLeft:8}}>Доступно: {availableQuantity} шт.</div>
                                                        </div>
                                                      );
                                                    })()}
                                                  </Form.Group>
                                                )}
                                                {/* Новое поле для изменения цены */}
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Цена для этой продажи</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        min="0"
                                                        step="0.01"
                                                        value={customPrice}
                                                        placeholder={
                                                            foundVariants.length > 0 && selectedVariantIdx >= 0
                                                              ? (foundVariants[selectedVariantIdx]?.price_with_discount ?? foundVariants[selectedVariantIdx]?.price ?? currentProduct.price)
                                                              : (foundVariants.length === 1 ? (foundVariants[0]?.price_with_discount ?? foundVariants[0]?.price ?? currentProduct.price) : currentProduct.price)
                                                        }
                                                        onChange={e => setCustomPrice(e.target.value)}
                                                        style={currentProduct.type === 'shoe' && foundVariants.length > 0 && selectedVariantIdx === -1 ? { borderColor: '#f00', background: '#fffbe6' } : {}}
                                                    />
                                                </Form.Group>
                                                {/* Для обуви только выбор варианта */}
                                                {currentProduct && (currentProduct.type === 'shoe' || currentProduct.type === 'clothes' || currentProduct.type === 'toy') && Array.isArray(foundVariants) && foundVariants.length > 0 && (
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>Выберите вариант</Form.Label>
                                                        <Form.Select value={selectedVariantIdx} onChange={e => {
                                                            const idx = Number(e.target.value);
                                                            setSelectedVariantIdx(idx);
                                                        }}>
                                                            <option value={-1}>Выберите вариант</option>
                                                            {foundVariants.map((v, idx) => (
                                                                <option
                                                                    key={[v.size, v.color, v.name, v.storeId, v.barcode, v.article].filter(Boolean).join('-') || idx}
                                                                    value={idx}
                                                                >
                                                                    {`${v.name || v.size || '[нет названия]'} / ${v.size || ''} ${v.color ? ' / ' + v.color : ''} (${v.quantity !== undefined ? v.quantity + ' шт.' : '—'}) — Магазин: ${v.storeName || v.storeId || '[нет магазина]'} / Штрих-код: ${v.barcode || '[нет штрих-кода]'} / Артикул: ${v.article || '[нет артикула]'}`}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                        {(() => {
                                                            // Подсказка под селектом: размер и цвет выбранного варианта
                                                            let variantToShow = null;
                                                            if (foundVariants.length === 1 && selectedVariantIdx === -1) {
                                                                variantToShow = foundVariants[0];
                                                            } else if (selectedVariantIdx >= 0 && foundVariants[selectedVariantIdx]) {
                                                                variantToShow = foundVariants[selectedVariantIdx];
                                                            }
                                                            if (!variantToShow) return null;
                                                            const sizeText = variantToShow.size || 'не указан';
                                                            const colorText = variantToShow.color || 'не указан';
                                                            return (
                                                                <div style={{ marginTop: 4, fontSize: 13 }}>
                                                                    <span style={{ color: '#16a34a', fontWeight: 600 }}>
                                                                        Размер: {sizeText}
                                                                    </span>
                                                                    <span style={{ color: '#ef4444', fontWeight: 600, marginLeft: 12 }}>
                                                                        Цвет: {colorText}
                                                                    </span>
                                                                </div>
                                                            );
                                                        })()}
                                                    </Form.Group>
                                                )}
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Способ оплаты</Form.Label>
                                                    <div>
                                                        <Form.Check
                                                            inline
                                                            label="Картой"
                                                            type="radio"
                                                            name="paymentType"
                                                            value="card"
                                                            checked={paymentType === 'card'}
                                                            onChange={() => setPaymentType('card')}
                                                        />
                                                        <Form.Check
                                                            inline
                                                            label="Наличными"
                                                            type="radio"
                                                            name="paymentType"
                                                            value="cash"
                                                            checked={paymentType === 'cash'}
                                                            onChange={() => setPaymentType('cash')}
                                                        />
                                                    </div>
                                                </Form.Group>
                                                <Button
                                                    variant="success"
                                                    onClick={handleAddToSale}
                                                    disabled={
                                                        ((currentProduct.type === 'shoe' || currentProduct.type === 'clothes' || currentProduct.type === 'toy') && foundVariants.length > 1 && selectedVariantIdx === -1) ||
                                                        (currentProduct.type === 'toy' && (() => {
                                                          // Проверяем количество выбранного варианта
                                                          if (foundVariants.length > 0 && selectedVariantIdx >= 0) {
                                                            return (foundVariants[selectedVariantIdx]?.quantity || 0) === 0;
                                                          } else if (foundVariants.length === 1) {
                                                            return (foundVariants[0]?.quantity || 0) === 0;
                                                          } else {
                                                            return ((currentProduct.product_stores?.[0]?.quantity || currentProduct.toy?.quantity || currentProduct.stock || 0) === 0);
                                                          }
                                                        })())
                                                    }
                                                >
                                                    Добавить в продажу
                                                </Button>
                                            </div>
                                        )}
                                        {Array.isArray(scannedProducts) && scannedProducts.length > 0 && (
                                            <div className="mt-4">
                                                <h5>Товары в продаже:</h5>
                                                <Table striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            <th>Название</th>
                                                            <th>Цена</th>
                                                            <th>Кол-во</th>
                                                            <th>Размер</th>
                                                            <th>Сумма</th>
                                                            <th>Действия</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(Array.isArray(scannedProducts) ? scannedProducts : []).map((product, index) => (
                                                            <tr key={index}>
                                                                <td>{product.name}</td>
                                                                <td>{product.price}</td>
                                                                <td style={{ width: 120 }}>
                                                                    <Form.Control
                                                                        type="number"
                                                                        min={1}
                                                                        max={product.product_stores?.[0]?.quantity || product.toy?.quantity || product.stock || undefined}
                                                                        value={Number(product.quantity) || 1}
                                                                        onChange={(e) => handleChangeProductQuantity(index, e.target.value)}
                                                                    />
                                                                </td>
                                                                <td>{getSizeValueById(product.selectedSize) || '-'}</td>
                                                                <td>{(Number(product.price) * (Number(product.quantity) || 1)).toFixed(2)} ₽</td>
                                                                <td>
                                                                    <Button
                                                                        variant="danger"
                                                                        size="sm"
                                                                        onClick={() => handleRemoveProduct(index)}
                                                                    >
                                                                        Удалить
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                {/* Итоговая сумма с учётом скидки */}
                                                <div className="text-end">
                                                    {userDiscount > 0 ? (
                                                        <h5>
                                                            <span style={{ textDecoration: 'line-through', color: '#888', marginRight: 8 }}>
                                                                {(Array.isArray(scannedProducts) ? scannedProducts.reduce((sum, product) => sum + (Number(product.price) * (Number(product.quantity) || 1)), 0) : 0)} ₽
                                                            </span>
                                                            <span style={{ fontWeight: 'bold', color: '#222' }}>
                                                                {(
                                                                    (Array.isArray(scannedProducts) ? scannedProducts.reduce((sum, product) => sum + (Number(product.price) * (Number(product.quantity) || 1)), 0) : 0)
                                                                    * (1 - userDiscount / 100)
                                                                ).toFixed(2)} ₽
                                                            </span>
                                                            <span style={{ color: '#0a0', fontSize: 14, marginLeft: 8 }}>
                                                                Скидка: {userDiscount}%
                                                            </span>
                                                        </h5>
                                                    ) : (
                                                        <h5>
                                                            Итого: {(Array.isArray(scannedProducts) ? scannedProducts.reduce((sum, product) => sum + (Number(product.price) * (Number(product.quantity) || 1)), 0) : 0)} ₽
                                                        </h5>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </Modal.Body>
                                    <Modal.Footer>
                                        {saleSuccess && <div className="text-success me-auto">{saleSuccess}</div>}
                                        <Button variant="secondary" onClick={handleCloseSaleForm}>
                                            Закрыть
                                        </Button>
                                        <Button
                                            variant="primary"
                                            disabled={Array.isArray(scannedProducts) && scannedProducts.length === 0}
                                            onClick={handleFinishSale}
                                        >
                                            Завершить продажу
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            )}
                            </Card.Body>
                        </Card>
                    )}

                    {activeTab === 'verification' && (
                        <Card>
                            <Card.Body>
                                <h3>Управление верификацией Email</h3>
                                
                                {message && (
                                    <Alert variant={messageType} dismissible onClose={() => setMessage('')}>
                                        {message}
                                    </Alert>
                                )}

                                <Row className="mt-4">
                                    <Col md={6}>
                                        <Card>
                                            <Card.Header>
                                                <h5>Статистика верификации</h5>
                                            </Card.Header>
                                            <Card.Body>
                                                {loading ? (
                                                    <div className="text-center">
                                                        <Spinner animation="border" />
                                                    </div>
                                                ) : verificationStats ? (
                                                    <div>
                                                        <Table striped bordered>
                                                            <tbody>
                                                                <tr>
                                                                    <td><strong>Всего пользователей:</strong></td>
                                                                    <td>{verificationStats.total}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Подтвержденных:</strong></td>
                                                                    <td className="text-success">{verificationStats.verified}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Не подтвержденных:</strong></td>
                                                                    <td className="text-warning">{verificationStats.unverified}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Истекших токенов:</strong></td>
                                                                    <td className="text-danger">{verificationStats.expiredTokens}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td><strong>Процент верификации:</strong></td>
                                                                    <td className="text-info">{verificationStats.verificationRate}%</td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                ) : (
                                                    <p>Нет данных</p>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    
                                    <Col md={6}>
                                        <Card>
                                            <Card.Header>
                                                <h5>Управление токенами</h5>
                                            </Card.Header>
                                            <Card.Body>
                                                <p>Очистка истекших токенов верификации поможет освободить место в базе данных и улучшить производительность.</p>
                                                <Button 
                                                    variant="warning" 
                                                    onClick={cleanupExpiredTokens}
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <Spinner animation="border" size="sm" className="me-2" />
                                                            Очистка...
                                                        </>
                                                    ) : (
                                                        'Очистить истекшие токены'
                                                    )}
                                                </Button>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    )}

                    {activeTab === 'changelog' && (
                        <ChangeLog />
                    )}
                    {activeTab === 'invoices' && (
                        <InvoicesStorage />
                    )}
                </Col>
            </Row>
            <Modal show={showReturnModal} onHide={handleCloseReturnModal} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Подтвердите возврат</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Вы уверены, что хотите вернуть товар <b>{saleToReturn?.product}</b> (заказ №{saleToReturn?.orderNum})?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseReturnModal}>
                        Отмена
                    </Button>
                    <Button variant="danger" onClick={confirmReturnSale}>
                        Подтвердить возврат
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showPaymentModal} onHide={handleClosePaymentModal} centered animation={false}>
              <Modal.Header closeButton>
                <Modal.Title>Выберите способ оплаты</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Check
                    type="radio"
                    label="Наличные"
                    name="paymentType"
                    value="cash"
                    checked={paymentTypeForOrder === 'cash'}
                    onChange={() => setPaymentTypeForOrder('cash')}
                  />
                  <Form.Check
                    type="radio"
                    label="Картой"
                    name="paymentType"
                    value="card"
                    checked={paymentTypeForOrder === 'card'}
                    onChange={() => setPaymentTypeForOrder('card')}
                  />
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClosePaymentModal}>
                  Отмена
                </Button>
                <Button variant="success" onClick={confirmCompleteOrder}>
                  Завершить заказ
                </Button>
              </Modal.Footer>
            </Modal>
            <Lightbox src={lightboxImg} alt="Фото товара" onClose={() => setLightboxImg(null)} />
            {/* Модальное окно для выбора товара из множественных товаров */}
            <Modal 
                show={showProductSelection} 
                onHide={handleCancelProductSelection} 
                size="lg" 
                centered 
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Выберите товар</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-3">
                        Найдено несколько товаров с штрих-кодом <strong>{barcode}</strong>. 
                        Выберите нужный товар:
                    </p>
                    <div className="row">
                        {multipleProducts.map((product, idx) => {
                            // Вспомогательная функция для расчета количества
                            const getQuantity = (product) => {
                                // Для товаров с вариантами (shoe, clothes, toy) суммируем количество из вариантов
                                if ((product.type === 'shoe' || product.type === 'clothes' || product.type === 'toy') && Array.isArray(product.variants) && product.variants.length > 0) {
                                    return (product.variants || []).reduce((sum, v) => sum + (Number(v.quantity) || 0), 0);
                                }
                                if (product.type === 'toy') {
                                    // Если нет вариантов, используем product_stores или stock как fallback
                                    if (Array.isArray(product.product_stores) && product.product_stores.length > 0) {
                                        return product.product_stores.reduce((sum, ps) => sum + (Number(ps.quantity) || 0), 0);
                                    }
                                    return Number(product.stock ?? product.toy?.quantity ?? 0) || 0;
                                } else if (product.type === 'shoe' || product.type === 'clothes') {
                                    return (product.variants || []).reduce((sum, v) => sum + (Number(v.quantity) || 0), 0);
                                }
                                if (Array.isArray(product.product_stores) && product.product_stores.length > 0) {
                                    return product.product_stores.reduce((sum, ps) => sum + (Number(ps.quantity) || 0), 0);
                                }
                                return Number(product.stock ?? 0) || 0;
                            };
                            
                            const quantity = getQuantity(product);
                            
                            return (
                            <div key={product.id} className="col-md-6 mb-3">
                                <div 
                                    className={`card ${selectedProductIdx === idx ? 'border-primary' : ''}`}
                                    style={{ 
                                        cursor: 'pointer',
                                        backgroundColor: quantity === 0 ? '#ffebee' : 'white'
                                    }}
                                    onClick={() => handleProductSelection(idx)}
                                >
                                    <div className="card-body">
                                        <h6 className="card-title">{product.name}</h6>
                                        <p className="card-text">
                                            <strong>Тип:</strong> {product.type === 'shoe' ? 'Обувь' : product.type === 'clothes' ? 'Одежда' : 'Игрушка'}<br/>
                                            <strong>Категория:</strong> {product.category || '-'}<br/>
                                            <strong>Цена:</strong> {product.price} ₽<br/>
                                            <strong>Количество:</strong> <span style={{
                                                color: quantity === 0 ? '#d32f2f' : (quantity <= 5 ? '#f57c00' : '#2e7d32'),
                                                fontWeight: 'bold'
                                            }}>{quantity} шт.</span><br/>
                                            {product.variants && product.variants.length > 0 && <><strong>Вариантов:</strong> {product.variants.length}</>}
                                        </p>
                                        {product.image_url && (
                                            <img 
                                                src={getImageUrl(product.image_url)} 
                                                alt={product.name}
                                                style={{ maxWidth: '100px', maxHeight: '100px', objectFit: 'cover' }}
                                                className="mb-2"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            );
                        })}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancelProductSelection}>
                        Отмена
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Модальные окна для категорий должны быть вне карточки! */}
            <Modal show={editCategoryModal} onHide={() => setEditCategoryModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Изменить категорию</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group>
                    <Form.Label>Название</Form.Label>
                    <Form.Control value={editCategoryName} onChange={e => setEditCategoryName(e.target.value)} />
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label>Тип</Form.Label>
                    <Form.Select value={editCategoryType} onChange={e => setEditCategoryType(e.target.value)}>
                      <option value="shoe">Обувь</option>
                      <option value="toy">Игрушка</option>
                      <option value="clothes">Одежда</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label>Родительская категория</Form.Label>
                    <Form.Select
                      value={editCategoryParentId || ''}
                      onChange={e => setEditCategoryParentId(e.target.value || '')}
                    >
                      <option value="">Без родителя (верхний уровень)</option>
                      {categories
                        .filter(cat => 
                          cat.type === editCategoryType && 
                          (!categoryToEdit || cat.id !== categoryToEdit.id)
                        )
                        .map(cat => (
                          <option key={cat.id} value={cat.id}>
                            {cat.name}
                          </option>
                        ))}
                    </Form.Select>
                  </Form.Group>
                  {categoryActionError && <div style={{ color: 'red', marginTop: 5 }}>{categoryActionError}</div>}
                </Form>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setEditCategoryModal(false)}>Отмена</Button>
                <Button variant="primary" onClick={handleEditCategorySave}>Сохранить</Button>
              </Modal.Footer>
            </Modal>
            <Modal show={deleteCategoryModal} onHide={() => setDeleteCategoryModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Удалить категорию</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>Вы уверены, что хотите удалить категорию <b>{categoryToDelete?.name}</b>?</div>
                {categoryActionError && <div style={{ color: 'red', marginTop: 5 }}>{categoryActionError}</div>}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={() => setDeleteCategoryModal(false)}>Отмена</Button>
                <Button variant="danger" onClick={handleDeleteCategoryConfirm}>Удалить</Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={categoryDiscountModal}
              onHide={() => {
                setCategoryDiscountModal(false);
                setCategoryActionError('');
              }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Скидка для категории</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  Установить скидку для категории <b>{discountCategory?.name}</b> и всех её подкатегорий.
                  Введите процент скидки от 0 до 100. Значение 0 снимет все скидки с товаров этих категорий.
                </p>
                <Form.Group>
                  <Form.Label>Скидка, %</Form.Label>
                  <Form.Control
                    type="number"
                    min={0}
                    max={100}
                    value={categoryDiscountValue}
                    onChange={e => setCategoryDiscountValue(e.target.value)}
                  />
                </Form.Group>
                {categoryActionError && <div style={{ color: 'red', marginTop: 5 }}>{categoryActionError}</div>}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => {
                    setCategoryDiscountModal(false);
                    setCategoryActionError('');
                  }}
                  disabled={categoryDiscountLoading}
                >
                  Отмена
                </Button>
                <Button
                  variant="primary"
                  onClick={handleApplyCategoryDiscount}
                  disabled={categoryDiscountLoading}
                >
                  {categoryDiscountLoading ? 'Применяем…' : 'Применить скидку'}
                </Button>
              </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default AdminPanel; 